import React from "react";
// @ts-ignore
import Variables from "styles/variables.scss";

function AppStore() {
	return (
		<svg width="120" height="35" viewBox="0 0 167 50" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="167" height="50" rx="25" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M82.21 18H81.27V10.76H82.21V18ZM54.9 18H57.36C58.3134 18 59.1167 17.6883 59.77 17.065C60.4234 16.4417 60.75 15.5767 60.75 14.47C60.75 13.3567 60.4267 12.485 59.78 11.855C59.1334 11.225 58.3334 10.91 57.38 10.91H54.9V18ZM57.33 17.13H55.88V11.78H57.35C58.0434 11.78 58.615 12.0133 59.065 12.48C59.515 12.9467 59.74 13.61 59.74 14.47C59.74 15.3233 59.5117 15.98 59.055 16.44C58.5984 16.9 58.0234 17.13 57.33 17.13ZM62.99 16.86C63.2834 17.16 63.64 17.31 64.06 17.31C64.48 17.31 64.835 17.1583 65.125 16.855C65.415 16.5517 65.56 16.13 65.56 15.59C65.56 15.0567 65.415 14.6383 65.125 14.335C64.835 14.0317 64.48 13.88 64.06 13.88C63.64 13.88 63.285 14.0317 62.995 14.335C62.705 14.6383 62.56 15.0567 62.56 15.59C62.56 16.13 62.7034 16.5533 62.99 16.86ZM64.06 13.04C63.3467 13.04 62.7567 13.2833 62.29 13.77C61.83 14.25 61.6 14.8567 61.6 15.59C61.6 16.33 61.83 16.9417 62.29 17.425C62.75 17.9083 63.34 18.15 64.06 18.15C64.78 18.15 65.37 17.9083 65.83 17.425C66.29 16.9417 66.52 16.33 66.52 15.59C66.52 14.8567 66.2884 14.2483 65.825 13.765C65.3617 13.2817 64.7734 13.04 64.06 13.04ZM70.43 13.19H71.4L72.65 16.81L73.71 13.19H74.7L73.14 18H72.17L70.89 14.34L69.64 18H68.65L67.07 13.19H68.1L69.18 16.81L70.43 13.19ZM76.59 18V15.22C76.59 14.84 76.6884 14.525 76.885 14.275C77.0817 14.025 77.3567 13.9 77.71 13.9C78.4567 13.9 78.83 14.3033 78.83 15.11V18H79.77V14.95C79.77 14.39 79.6217 13.9333 79.325 13.58C79.0284 13.2267 78.6034 13.05 78.05 13.05C77.3834 13.05 76.89 13.3267 76.57 13.88V13.19H75.65V18H76.59ZM85.87 17.31C85.45 17.31 85.0934 17.16 84.8 16.86C84.5134 16.5533 84.37 16.13 84.37 15.59C84.37 15.0567 84.515 14.6383 84.805 14.335C85.095 14.0317 85.45 13.88 85.87 13.88C86.29 13.88 86.645 14.0317 86.935 14.335C87.225 14.6383 87.37 15.0567 87.37 15.59C87.37 16.13 87.225 16.5517 86.935 16.855C86.645 17.1583 86.29 17.31 85.87 17.31ZM84.1 13.77C84.5667 13.2833 85.1567 13.04 85.87 13.04C86.5834 13.04 87.1717 13.2817 87.635 13.765C88.0984 14.2483 88.33 14.8567 88.33 15.59C88.33 16.33 88.1 16.9417 87.64 17.425C87.18 17.9083 86.59 18.15 85.87 18.15C85.15 18.15 84.56 17.9083 84.1 17.425C83.64 16.9417 83.41 16.33 83.41 15.59C83.41 14.8567 83.64 14.25 84.1 13.77ZM89.63 15.715C89.3634 15.965 89.23 16.2967 89.23 16.71C89.23 17.1033 89.38 17.4417 89.68 17.725C89.98 18.0083 90.3667 18.15 90.84 18.15C91.2267 18.15 91.5484 18.07 91.805 17.91C92.0617 17.75 92.2567 17.5633 92.39 17.35C92.39 17.5833 92.4067 17.8 92.44 18H93.36C93.32 17.76 93.3 17.4967 93.3 17.21V14.8C93.3 14.2867 93.1367 13.865 92.81 13.535C92.4834 13.205 91.98 13.04 91.3 13.04C90.78 13.04 90.3334 13.185 89.96 13.475C89.5867 13.765 89.3767 14.14 89.33 14.6L90.23 14.81C90.2634 14.5167 90.3734 14.2817 90.56 14.105C90.7467 13.9283 91 13.84 91.32 13.84C91.6667 13.84 91.9267 13.92 92.1 14.08C92.2734 14.24 92.36 14.4467 92.36 14.7C92.36 14.9067 92.2367 15.0267 91.99 15.06L90.69 15.25C90.25 15.31 89.8967 15.465 89.63 15.715ZM90.97 17.36C91.39 17.36 91.7267 17.2467 91.98 17.02C92.2334 16.7933 92.36 16.4333 92.36 15.94V15.72L90.89 15.94C90.6767 15.9733 90.5067 16.05 90.38 16.17C90.2534 16.29 90.19 16.4533 90.19 16.66C90.19 16.8467 90.2617 17.01 90.405 17.15C90.5484 17.29 90.7367 17.36 90.97 17.36ZM95.695 16.82C95.445 16.5 95.32 16.0867 95.32 15.58C95.32 15.08 95.45 14.6733 95.71 14.36C95.97 14.0467 96.3134 13.89 96.74 13.89C97.1667 13.89 97.5034 14.0433 97.75 14.35C97.9967 14.6567 98.12 15.06 98.12 15.56C98.12 16.0667 97.9934 16.4833 97.74 16.81C97.4867 17.1367 97.15 17.3 96.73 17.3C96.29 17.3 95.945 17.14 95.695 16.82ZM98.1331 17.5294L98.13 17.27C98.0034 17.5167 97.8117 17.7217 97.555 17.885C97.2984 18.0483 96.9934 18.13 96.64 18.13C95.9534 18.13 95.4017 17.8883 94.985 17.405C94.5684 16.9217 94.36 16.3133 94.36 15.58C94.36 14.88 94.5734 14.285 95 13.795C95.4267 13.305 95.9734 13.06 96.64 13.06C97.0334 13.06 97.3534 13.1383 97.6 13.295C97.8467 13.4517 98.0167 13.6433 98.11 13.87V10.76H99.04V17.11C99.04 17.4367 99.0567 17.7333 99.09 18H98.18C98.155 17.86 98.1394 17.7031 98.1331 17.5294ZM105.2 17.31C104.78 17.31 104.423 17.16 104.13 16.86C103.843 16.5533 103.7 16.13 103.7 15.59C103.7 15.0567 103.845 14.6383 104.135 14.335C104.425 14.0317 104.78 13.88 105.2 13.88C105.62 13.88 105.975 14.0317 106.265 14.335C106.555 14.6383 106.7 15.0567 106.7 15.59C106.7 16.13 106.555 16.5517 106.265 16.855C105.975 17.1583 105.62 17.31 105.2 17.31ZM103.43 13.77C103.897 13.2833 104.487 13.04 105.2 13.04C105.913 13.04 106.502 13.2817 106.965 13.765C107.428 14.2483 107.66 14.8567 107.66 15.59C107.66 16.33 107.43 16.9417 106.97 17.425C106.51 17.9083 105.92 18.15 105.2 18.15C104.48 18.15 103.89 17.9083 103.43 17.425C102.97 16.9417 102.74 16.33 102.74 15.59C102.74 14.8567 102.97 14.25 103.43 13.77ZM109.8 18V15.22C109.8 14.84 109.898 14.525 110.095 14.275C110.292 14.025 110.567 13.9 110.92 13.9C111.667 13.9 112.04 14.3033 112.04 15.11V18H112.98V14.95C112.98 14.39 112.832 13.9333 112.535 13.58C112.238 13.2267 111.813 13.05 111.26 13.05C110.593 13.05 110.1 13.3267 109.78 13.88V13.19H108.86V18H109.8ZM118.24 11.67V13.19H119.28V14.04H118.24V16.54C118.24 16.7667 118.292 16.9333 118.395 17.04C118.498 17.1467 118.67 17.2 118.91 17.2C119.05 17.2 119.173 17.1867 119.28 17.16V17.96C119.12 18.02 118.907 18.05 118.64 18.05C118.227 18.05 117.9 17.93 117.66 17.69C117.42 17.45 117.3 17.1133 117.3 16.68V14.04H116.38V13.19H116.64C116.887 13.19 117.072 13.1217 117.195 12.985C117.318 12.8483 117.38 12.67 117.38 12.45V11.67H118.24ZM121.47 18V15.17C121.483 14.7967 121.587 14.4917 121.78 14.255C121.973 14.0183 122.243 13.9 122.59 13.9C123.337 13.9 123.71 14.3033 123.71 15.11V18H124.65V14.95C124.65 14.39 124.502 13.9333 124.205 13.58C123.908 13.2267 123.483 13.05 122.93 13.05C122.277 13.05 121.79 13.2833 121.47 13.75V10.76H120.53V18H121.47ZM126.76 15.1H129.39C129.377 14.74 129.257 14.445 129.03 14.215C128.803 13.985 128.483 13.87 128.07 13.87C127.697 13.87 127.39 13.9917 127.15 14.235C126.91 14.4783 126.78 14.7667 126.76 15.1ZM130.34 16.63L129.53 16.35C129.317 16.9967 128.867 17.32 128.18 17.32C127.773 17.32 127.432 17.1833 127.155 16.91C126.878 16.6367 126.737 16.2867 126.73 15.86H130.35C130.363 15.78 130.37 15.68 130.37 15.56C130.37 14.7933 130.167 14.1817 129.76 13.725C129.353 13.2683 128.787 13.04 128.06 13.04C127.433 13.04 126.893 13.28 126.44 13.76C125.987 14.24 125.76 14.8467 125.76 15.58C125.76 16.3667 125.995 16.9917 126.465 17.455C126.935 17.9183 127.507 18.15 128.18 18.15C128.72 18.15 129.18 18.0083 129.56 17.725C129.94 17.4417 130.2 17.0767 130.34 16.63Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M63.12 37H65.216L60.8 25.656H58.576L54.16 37H56.192L57.248 34.152H62.048L63.12 37ZM59.648 27.736L61.376 32.376H57.92L59.648 27.736ZM68.416 40.04V36.12C68.816 36.712 69.664 37.192 70.784 37.192C73.024 37.192 74.448 35.432 74.448 33.096C74.448 30.792 73.152 29.032 70.848 29.032C69.648 29.032 68.752 29.592 68.368 30.264V29.208H66.576V40.04H68.416ZM72.592 33.096C72.592 34.584 71.728 35.544 70.496 35.544C69.28 35.544 68.4 34.584 68.4 33.096C68.4 31.64 69.28 30.68 70.496 30.68C71.744 30.68 72.592 31.64 72.592 33.096ZM78.08 40.04V36.12C78.48 36.712 79.328 37.192 80.448 37.192C82.688 37.192 84.112 35.432 84.112 33.096C84.112 30.792 82.816 29.032 80.512 29.032C79.312 29.032 78.416 29.592 78.032 30.264V29.208H76.24V40.04H78.08ZM82.256 33.096C82.256 34.584 81.392 35.544 80.16 35.544C78.944 35.544 78.064 34.584 78.064 33.096C78.064 31.64 78.944 30.68 80.16 30.68C81.408 30.68 82.256 31.64 82.256 33.096ZM97.488 28.312C97.232 27.048 96.192 25.416 93.52 25.416C91.408 25.416 89.664 26.984 89.664 28.888C89.664 30.584 90.816 31.72 92.544 32.072L94.144 32.408C95.12 32.616 95.664 33.208 95.664 33.944C95.664 34.824 94.96 35.512 93.6 35.512C91.968 35.512 91.12 34.424 91.008 33.24L89.216 33.752C89.392 35.384 90.72 37.24 93.6 37.24C96.192 37.24 97.616 35.56 97.616 33.8C97.616 32.2 96.544 30.936 94.544 30.536L92.912 30.2C92.032 30.008 91.584 29.464 91.584 28.744C91.584 27.88 92.384 27.112 93.536 27.112C95.056 27.112 95.648 28.152 95.76 28.856L97.488 28.312ZM101.808 26.824H100.128V27.992C100.128 28.68 99.76 29.208 98.928 29.208H98.528V30.856H99.968V34.776C99.968 36.232 100.864 37.096 102.304 37.096C102.976 37.096 103.328 36.968 103.44 36.92V35.384L103.235 35.4159C103.108 35.4323 102.946 35.448 102.8 35.448C102.112 35.448 101.808 35.16 101.808 34.472V30.856H103.424V29.208H101.808V26.824ZM108.72 35.576C107.584 35.576 106.544 34.712 106.544 33.096C106.544 31.48 107.584 30.648 108.72 30.648C109.872 30.648 110.896 31.48 110.896 33.096C110.896 34.728 109.872 35.576 108.72 35.576ZM108.72 28.968C106.4 28.968 104.688 30.712 104.688 33.096C104.688 35.496 106.4 37.24 108.72 37.24C111.056 37.24 112.768 35.496 112.768 33.096C112.768 30.712 111.056 28.968 108.72 28.968ZM119.12 29.16C119.04 29.144 118.848 29.112 118.624 29.112C117.6 29.112 116.736 29.608 116.368 30.456V29.208H114.56V37H116.416V33.288C116.416 31.832 117.072 31 118.512 31C118.704 31 118.912 31.016 119.12 31.048V29.16ZM121.936 32.248C122 31.416 122.672 30.52 123.84 30.52C125.12 30.52 125.728 31.336 125.76 32.248H121.936ZM125.968 34.28L127.536 34.776C127.12 36.136 125.888 37.24 124.016 37.24C121.904 37.24 120.032 35.704 120.032 33.064C120.032 30.6 121.856 28.968 123.824 28.968C126.224 28.968 127.632 30.552 127.632 33.016C127.632 33.32 127.6 33.576 127.584 33.608H121.888C121.936 34.792 122.864 35.64 124.016 35.64C125.136 35.64 125.712 35.048 125.968 34.28Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.3938 14.5376C32.263 13.6005 32.8511 12.2986 32.6906 11C31.4371 11.0451 29.9185 11.7405 29.0204 12.6773C28.2133 13.5075 27.5079 14.8334 27.6963 16.1059C29.0955 16.2022 30.5228 15.4737 31.3938 14.5376ZM34.0616 23.502C34.0346 20.5912 36.3495 19.1944 36.4534 19.1258C35.1524 17.1502 33.125 16.8795 32.4037 16.8493C30.6791 16.6669 29.0385 17.902 28.1625 17.902C27.2897 17.902 25.9395 16.8737 24.5086 16.9009C22.628 16.9318 20.8947 18.035 19.9278 19.7834C17.974 23.3 19.4266 28.5109 21.3313 31.3629C22.2618 32.7597 23.3706 34.3261 24.8264 34.269C26.2303 34.2131 26.7604 33.3279 28.4561 33.3279C30.1509 33.3279 30.6278 34.269 32.1111 34.2407C33.6204 34.2131 34.5769 32.8174 35.5009 31.4171C36.5685 29.7983 37.008 28.23 37.0347 28.1505C37.0008 28.133 34.0923 26.979 34.0616 23.502Z"
				fill="black"
			/>
		</svg>
	);
}

function GooglePlay() {
	return (
		<svg width="120" height="35" viewBox="0 0 167 50" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="167" height="50" rx="25" fill="white" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M73.71 12.37C73.71 12.5567 73.7733 12.7167 73.9 12.85C74.0333 12.9767 74.1933 13.04 74.38 13.04C74.5667 13.04 74.7267 12.975 74.86 12.845C74.9933 12.715 75.06 12.5567 75.06 12.37C75.06 12.1767 74.9933 12.015 74.86 11.885C74.7267 11.755 74.5667 11.69 74.38 11.69C74.1933 11.69 74.035 11.7567 73.905 11.89C73.775 12.0233 73.71 12.1833 73.71 12.37ZM60.25 19H61.04V15.53H57.65V16.41H60.11C60.0967 16.61 60.0483 16.81 59.965 17.01C59.8817 17.21 59.7583 17.4083 59.595 17.605C59.4317 17.8017 59.205 17.96 58.915 18.08C58.625 18.2 58.2933 18.26 57.92 18.26C57.24 18.26 56.6583 18.015 56.175 17.525C55.6917 17.035 55.45 16.3433 55.45 15.45C55.45 14.5633 55.6967 13.8767 56.19 13.39C56.6833 12.9033 57.2733 12.66 57.96 12.66C58.5067 12.66 58.9783 12.8017 59.375 13.085C59.7717 13.3683 60.05 13.7667 60.21 14.28L61.1 13.9C60.8933 13.2533 60.5083 12.735 59.945 12.345C59.3817 11.955 58.72 11.76 57.96 11.76C57.36 11.76 56.7983 11.8967 56.275 12.17C55.7517 12.4433 55.3167 12.8667 54.97 13.44C54.6233 14.0133 54.45 14.6833 54.45 15.45C54.45 16.2167 54.615 16.8867 54.945 17.46C55.275 18.0333 55.6967 18.4583 56.21 18.735C56.7233 19.0117 57.2833 19.15 57.89 19.15C58.4433 19.15 58.9167 19.0367 59.31 18.81C59.7033 18.5833 59.9867 18.3133 60.16 18L60.25 19ZM65.69 16.1H63.06C63.08 15.7667 63.21 15.4783 63.45 15.235C63.69 14.9917 63.9967 14.87 64.37 14.87C64.7833 14.87 65.1033 14.985 65.33 15.215C65.5567 15.445 65.6767 15.74 65.69 16.1ZM65.83 17.35L66.64 17.63C66.5 18.0767 66.24 18.4417 65.86 18.725C65.48 19.0083 65.02 19.15 64.48 19.15C63.8067 19.15 63.235 18.9183 62.765 18.455C62.295 17.9917 62.06 17.3667 62.06 16.58C62.06 15.8467 62.2867 15.24 62.74 14.76C63.1933 14.28 63.7333 14.04 64.36 14.04C65.0867 14.04 65.6533 14.2683 66.06 14.725C66.4667 15.1817 66.67 15.7933 66.67 16.56C66.67 16.68 66.6633 16.78 66.65 16.86H63.03C63.0367 17.2867 63.1783 17.6367 63.455 17.91C63.7317 18.1833 64.0733 18.32 64.48 18.32C65.1667 18.32 65.6167 17.9967 65.83 17.35ZM69.13 14.19V12.67H68.27V13.45C68.27 13.67 68.2083 13.8483 68.085 13.985C67.9617 14.1217 67.7767 14.19 67.53 14.19H67.27V15.04H68.19V17.68C68.19 18.1133 68.31 18.45 68.55 18.69C68.79 18.93 69.1167 19.05 69.53 19.05C69.7967 19.05 70.01 19.02 70.17 18.96V18.16C70.0633 18.1867 69.94 18.2 69.8 18.2C69.56 18.2 69.3883 18.1467 69.285 18.04C69.1817 17.9333 69.13 17.7667 69.13 17.54V15.04H70.17V14.19H69.13ZM74.85 19H73.92V14.19H74.85V19ZM77.71 12.67V14.19H78.75V15.04H77.71V17.54C77.71 17.7667 77.7617 17.9333 77.865 18.04C77.9683 18.1467 78.14 18.2 78.38 18.2C78.52 18.2 78.6433 18.1867 78.75 18.16V18.96C78.59 19.02 78.3767 19.05 78.11 19.05C77.6967 19.05 77.37 18.93 77.13 18.69C76.89 18.45 76.77 18.1133 76.77 17.68V15.04H75.85V14.19H76.11C76.3567 14.19 76.5417 14.1217 76.665 13.985C76.7883 13.8483 76.85 13.67 76.85 13.45V12.67H77.71ZM84.56 18.31C84.14 18.31 83.7833 18.16 83.49 17.86C83.2033 17.5533 83.06 17.13 83.06 16.59C83.06 16.0567 83.205 15.6383 83.495 15.335C83.785 15.0317 84.14 14.88 84.56 14.88C84.98 14.88 85.335 15.0317 85.625 15.335C85.915 15.6383 86.06 16.0567 86.06 16.59C86.06 17.13 85.915 17.5517 85.625 17.855C85.335 18.1583 84.98 18.31 84.56 18.31ZM82.79 14.77C83.2567 14.2833 83.8467 14.04 84.56 14.04C85.2733 14.04 85.8617 14.2817 86.325 14.765C86.7883 15.2483 87.02 15.8567 87.02 16.59C87.02 17.33 86.79 17.9417 86.33 18.425C85.87 18.9083 85.28 19.15 84.56 19.15C83.84 19.15 83.25 18.9083 82.79 18.425C82.33 17.9417 82.1 17.33 82.1 16.59C82.1 15.8567 82.33 15.25 82.79 14.77ZM89.16 19V16.22C89.16 15.84 89.2583 15.525 89.455 15.275C89.6517 15.025 89.9267 14.9 90.28 14.9C91.0267 14.9 91.4 15.3033 91.4 16.11V19H92.34V15.95C92.34 15.39 92.1917 14.9333 91.895 14.58C91.5983 14.2267 91.1733 14.05 90.62 14.05C89.9533 14.05 89.46 14.3267 89.14 14.88V14.19H88.22V19H89.16Z"
				fill="#0A142F"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M65.424 30.256V36H63.872L63.728 34.56C63.232 35.392 62.064 36.24 60.256 36.24C57.296 36.24 54.672 34.064 54.672 30.32C54.672 26.592 57.44 24.416 60.384 24.416C63.136 24.416 64.896 26 65.504 27.872L63.696 28.56C63.312 27.28 62.192 26.192 60.384 26.192C58.544 26.192 56.624 27.504 56.624 30.32C56.624 33.088 58.416 34.48 60.368 34.48C62.656 34.48 63.52 32.912 63.616 31.936H59.872V30.256H65.424ZM68.832 32.096C68.832 33.712 69.872 34.576 71.008 34.576C72.16 34.576 73.184 33.728 73.184 32.096C73.184 30.48 72.16 29.648 71.008 29.648C69.872 29.648 68.832 30.48 68.832 32.096ZM71.008 27.968C68.688 27.968 66.976 29.712 66.976 32.096C66.976 34.496 68.688 36.24 71.008 36.24C73.344 36.24 75.056 34.496 75.056 32.096C75.056 29.712 73.344 27.968 71.008 27.968ZM78.096 32.096C78.096 33.712 79.136 34.576 80.272 34.576C81.424 34.576 82.448 33.728 82.448 32.096C82.448 30.48 81.424 29.648 80.272 29.648C79.136 29.648 78.096 30.48 78.096 32.096ZM80.272 27.968C77.952 27.968 76.24 29.712 76.24 32.096C76.24 34.496 77.952 36.24 80.272 36.24C82.608 36.24 84.32 34.496 84.32 32.096C84.32 29.712 82.608 27.968 80.272 27.968ZM89.264 39.28C87.2 39.28 85.76 38 85.552 36.432L87.264 35.984C87.392 36.944 88.144 37.664 89.216 37.664C90.688 37.664 91.424 36.912 91.424 35.328V34.512C91.088 35.12 90.304 35.648 89.168 35.648C87.088 35.648 85.568 34.048 85.568 31.856C85.568 29.776 87.024 28.064 89.168 28.064C90.384 28.064 91.136 28.56 91.472 29.2V28.208H93.264V35.264C93.264 37.344 92.192 39.28 89.264 39.28ZM89.472 34.064C88.256 34.064 87.44 33.216 87.44 31.856C87.44 30.528 88.288 29.664 89.472 29.664C90.624 29.664 91.472 30.528 91.472 31.856C91.472 33.2 90.656 34.064 89.472 34.064ZM97.392 24.416V36H95.536V24.416H97.392ZM101.088 31.248C101.152 30.416 101.824 29.52 102.992 29.52C104.272 29.52 104.88 30.336 104.912 31.248H101.088ZM103.168 34.64C104.288 34.64 104.864 34.048 105.12 33.28L106.688 33.776C106.272 35.136 105.04 36.24 103.168 36.24C101.056 36.24 99.184 34.704 99.184 32.064C99.184 29.6 101.008 27.968 102.976 27.968C105.376 27.968 106.784 29.552 106.784 32.016C106.784 32.32 106.752 32.576 106.736 32.608H101.04C101.088 33.792 102.016 34.64 103.168 34.64ZM114.608 29.872V26.352H116.608C117.824 26.352 118.56 27.04 118.56 28.128C118.56 29.2 117.824 29.872 116.608 29.872H114.608ZM120.512 28.112C120.512 30.112 119.072 31.568 116.896 31.568H114.608V36H112.688V24.656H116.896C119.072 24.656 120.512 26.128 120.512 28.112ZM124.016 36V24.416H122.16V36H124.016ZM128.576 36.24C126.944 36.24 125.936 35.12 125.936 33.888C125.936 32.496 126.96 31.728 128.288 31.536L130.288 31.232C130.736 31.168 130.864 30.944 130.864 30.672C130.864 30.016 130.416 29.488 129.392 29.488C128.416 29.488 127.872 30.112 127.792 30.896L126.096 30.512C126.24 29.168 127.456 27.968 129.376 27.968C131.776 27.968 132.688 29.328 132.688 30.88L132.69 34.9229C132.697 35.3097 132.727 35.6107 132.752 35.7973L132.784 36H131.056C131.04 35.952 130.976 35.632 130.976 35.008C130.608 35.6 129.84 36.24 128.576 36.24ZM128.928 34.784C128.192 34.784 127.792 34.304 127.792 33.776C127.792 33.136 128.256 32.816 128.832 32.72L130.864 32.416V32.768C130.864 34.288 129.968 34.784 128.928 34.784ZM135.312 39.152H137.296L142.256 28.208H140.288L138.192 33.136L135.952 28.208H133.856L137.184 35.072L135.312 39.152Z"
				fill="#0A142F"
			/>
			<path
				d="M20.0958 14.1295C20.0395 14.3301 20 14.5454 20 14.7921V35.1066C20 35.35 20.038 35.5641 20.0932 35.7621L31.4206 24.9602L20.0958 14.1295Z"
				fill="#48A0DC"
			/>
			<path
				d="M22.6161 13.3405C22.0889 13.0169 21.5691 12.9359 21.1302 13.0476L32.5049 23.9264L35.8415 20.7452L22.6161 13.3405Z"
				fill="#88C057"
			/>
			<path
				d="M40.7173 23.4753L37.1869 21.4986L33.5714 24.9464L37.2547 28.4699L40.6901 26.5713C42.3654 25.6101 41.7535 24.0614 40.7173 23.4753Z"
				fill="#FFCC66"
			/>
			<path
				d="M32.4867 25.9799L21.0978 36.8391C21.5434 36.9647 22.0751 36.8901 22.6158 36.5582L35.8825 29.2274L32.4867 25.9799Z"
				fill="#ED7161"
			/>
		</svg>
	);
}

function Home({ color, smaller }: any) {
	return (
		<svg
			width={smaller ? "17.5" : "24"}
			height={smaller ? "15" : "24"}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.15722 20.7714V17.7047C9.1572 16.9246 9.79312 16.2908 10.581 16.2856H13.4671C14.2587 16.2856 14.9005 16.9209 14.9005 17.7047V17.7047V20.7809C14.9003 21.4432 15.4343 21.9845 16.103 22H18.0271C19.9451 22 21.5 20.4607 21.5 18.5618V18.5618V9.83784C21.4898 9.09083 21.1355 8.38935 20.538 7.93303L13.9577 2.6853C12.8049 1.77157 11.1662 1.77157 10.0134 2.6853L3.46203 7.94256C2.86226 8.39702 2.50739 9.09967 2.5 9.84736V18.5618C2.5 20.4607 4.05488 22 5.97291 22H7.89696C8.58235 22 9.13797 21.4499 9.13797 20.7714V20.7714"
				stroke={color === "blue" ? Variables.darkPrimaryColor : "white"}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function HomeFilled() {
	return (
		<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.13478 18.7733V15.7156C7.13478 14.9351 7.77217 14.3023 8.55844 14.3023H11.4326C11.8102 14.3023 12.1723 14.4512 12.4393 14.7163C12.7063 14.9813 12.8563 15.3408 12.8563 15.7156V18.7733C12.8539 19.0978 12.9821 19.4099 13.2124 19.6402C13.4427 19.8705 13.7561 20 14.0829 20H16.0438C16.9596 20.0023 17.8388 19.6428 18.4872 19.0008C19.1356 18.3588 19.5 17.487 19.5 16.5778V7.86686C19.5 7.13246 19.1721 6.43584 18.6046 5.96467L11.934 0.675869C10.7737 -0.251438 9.11111 -0.221498 7.98539 0.746979L1.46701 5.96467C0.872741 6.42195 0.517552 7.12064 0.5 7.86686V16.5689C0.5 18.4639 2.04738 20 3.95617 20H5.87229C6.55123 20 7.103 19.4562 7.10792 18.7822L7.13478 18.7733Z"
				fill="white"
			/>
		</svg>
	);
}

function CalendarFilled({ smaller, color, bigger }: any) {
	let width = 24,
		height = 24;
	if (smaller) {
		width = 16;
		height = 15;
	} else if (bigger) {
		width = 40;
		height = 40;
	}

	return (
		<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.4109 2.76862L16.4119 3.51824C19.1665 3.73414 20.9862 5.6112 20.9891 8.48975L21 16.9155C21.0039 20.054 19.0322 21.985 15.8718 21.99L8.15189 22C5.0112 22.004 3.01482 20.027 3.01087 16.8796L3.00001 8.55272C2.99606 5.65517 4.75153 3.78311 7.50618 3.53024L7.50519 2.78061C7.5042 2.34083 7.83002 2.01 8.26445 2.01C8.69887 2.009 9.02469 2.33883 9.02568 2.77861L9.02666 3.47826L14.8914 3.47027L14.8904 2.77062C14.8894 2.33084 15.2152 2.001 15.6497 2C16.0742 1.99901 16.4099 2.32884 16.4109 2.76862ZM4.52149 8.86157L19.4696 8.84158V8.49175C19.4272 6.34283 18.349 5.21539 16.4139 5.04748L16.4148 5.81709C16.4148 6.24688 16.0801 6.58771 15.6556 6.58771C15.2212 6.58871 14.8944 6.24888 14.8944 5.81909L14.8934 5.0095L9.02864 5.01749L9.02962 5.82609C9.02962 6.25687 8.70479 6.5967 8.27037 6.5967C7.83595 6.5977 7.50914 6.25887 7.50914 5.82809L7.50815 5.05847C5.58286 5.25138 4.51754 6.38281 4.5205 8.55072L4.52149 8.86157ZM15.2399 13.4043V13.4153C15.2498 13.8751 15.625 14.2239 16.0801 14.2139C16.5244 14.2029 16.8789 13.8221 16.869 13.3623C16.8483 12.9225 16.4918 12.5637 16.0485 12.5647C15.5944 12.5747 15.2389 12.9445 15.2399 13.4043ZM16.0554 17.892C15.6013 17.882 15.235 17.5032 15.234 17.0435C15.2241 16.5837 15.5884 16.2029 16.0426 16.1919H16.0525C16.5165 16.1919 16.8927 16.5707 16.8927 17.0405C16.8937 17.5102 16.5185 17.891 16.0554 17.892ZM11.1721 13.4203C11.1919 13.8801 11.568 14.2389 12.0222 14.2189C12.4665 14.1979 12.821 13.8181 12.8012 13.3583C12.7904 12.9085 12.425 12.5587 11.9807 12.5597C11.5266 12.5797 11.1711 12.9605 11.1721 13.4203ZM12.0262 17.8471C11.572 17.8671 11.1968 17.5082 11.1761 17.0485C11.1761 16.5887 11.5305 16.2089 11.9847 16.1879C12.429 16.1869 12.7953 16.5367 12.8052 16.9855C12.8259 17.4463 12.4705 17.8261 12.0262 17.8471ZM7.10434 13.4553C7.12408 13.915 7.50025 14.2749 7.95442 14.2539C8.39872 14.2339 8.75317 13.8531 8.73244 13.3933C8.72257 12.9435 8.35725 12.5937 7.91197 12.5947C7.4578 12.6147 7.10335 12.9955 7.10434 13.4553ZM7.95837 17.8521C7.5042 17.8731 7.12902 17.5132 7.10828 17.0535C7.1073 16.5937 7.46274 16.2129 7.91691 16.1929C8.3612 16.1919 8.7275 16.5417 8.73738 16.9915C8.75811 17.4513 8.40366 17.8321 7.95837 17.8521Z"
				fill={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
			/>
		</svg>
	);
}

function Calendar({ smaller, color, bigger, date }: any) {
	let width = 24,
		height = 24;
	if (smaller) {
		width = 16;
		height = 15;
	} else if (bigger) {
		width = 40;
		height = 40;
	} else if (date) {
		width = 14;
		height = 13;
	}

	return (
		<svg width={width} height={height} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.09265 8.40421H18.9166"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.4421 12.3097H14.4514"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.0046 12.3097H10.0139"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.55787 12.3097H5.56714"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.4421 16.1962H14.4514"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.0046 16.1962H10.0139"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.55787 16.1962H5.56714"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.0437 1V4.29078"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.96552 1V4.29078"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.2383 2.5791H5.77096C2.83427 2.5791 1 4.21504 1 7.22213V16.2718C1 19.3261 2.83427 20.9999 5.77096 20.9999H14.229C17.175 20.9999 19 19.3545 19 16.3474V7.22213C19.0092 4.21504 17.1842 2.5791 14.2383 2.5791Z"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Chat() {
	return (
		<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.0018 0C13.9425 0 16.7061 1.1433 18.7819 3.22006C23.0727 7.51075 23.0727 14.4913 18.7819 18.782C16.6785 20.8864 13.8463 22 10.9772 22C9.41318 22 7.83893 21.6694 6.36602 20.9877C5.93203 20.8137 5.52567 20.6499 5.23395 20.6499C4.89822 20.652 4.44683 20.8076 4.01079 20.958C3.11619 21.2651 2.00255 21.6479 1.17857 20.827C0.357673 20.0051 0.736393 18.8946 1.04142 18.001C1.19188 17.5609 1.34644 17.1064 1.34644 16.7625C1.34644 16.48 1.21031 16.1198 1.0015 15.6008C-0.915646 11.4606 -0.029236 6.47083 3.22264 3.22108C5.29844 1.14432 8.06105 0 11.0018 0ZM11.0028 1.53531C8.4715 1.53531 6.09375 2.51996 4.30762 4.30706C1.50919 7.10338 0.747652 11.3971 2.41095 14.9928C2.65047 15.5855 2.88179 16.1627 2.88179 16.7625C2.88179 17.3613 2.67606 17.9642 2.49488 18.4964C2.34544 18.9345 2.11923 19.5957 2.26458 19.741C2.40686 19.8884 3.07218 19.6561 3.51129 19.5056C4.03842 19.3255 4.63619 19.1187 5.22883 19.1146C5.8225 19.1146 6.3824 19.3398 6.97504 19.5783C10.6056 21.2569 14.8995 20.4933 17.6969 17.697C21.3879 14.0041 21.3879 7.99693 17.6969 4.30604C15.9098 2.51894 13.533 1.53531 11.0028 1.53531ZM15.0427 10.4019C15.6077 10.4019 16.0663 10.8595 16.0663 11.4255C16.0663 11.9915 15.6077 12.449 15.0427 12.449C14.4777 12.449 14.015 11.9915 14.015 11.4255C14.015 10.8595 14.4685 10.4019 15.0335 10.4019H15.0427ZM10.9394 10.4019C11.5044 10.4019 11.963 10.8595 11.963 11.4255C11.963 11.9915 11.5044 12.449 10.9394 12.449C10.3744 12.449 9.91176 11.9915 9.91176 11.4255C9.91176 10.8595 10.3642 10.4019 10.9302 10.4019H10.9394ZM6.83573 10.4019C7.40074 10.4019 7.8593 10.8595 7.8593 11.4255C7.8593 11.9915 7.40074 12.449 6.83573 12.449C6.27072 12.449 5.80807 11.9915 5.80807 11.4255C5.80807 10.8595 6.26151 10.4019 6.82652 10.4019H6.83573Z"
				fill="white"
			/>
		</svg>
	);
}

function ChatFilled({ color, bigger }: any) {
	if (color) {
		return (
			<svg
				width={bigger ? "25" : "20"}
				height={bigger ? "26" : "21"}
				viewBox="0 0 20 21"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M10.02 0.5C15.7 0.5 20 5.15699 20 10.485C20 16.6642 14.96 20.5 10 20.5C8.36 20.5 6.54 20.0593 5.08 19.198C4.57 18.8876 4.14 18.6572 3.59 18.8375L1.57 19.4384C1.06 19.5986 0.6 19.198 0.75 18.6572L1.42 16.4139C1.53 16.1034 1.51 15.7729 1.35 15.5125C0.49 13.9301 0 12.1975 0 10.515C0 5.24712 4.21 0.5 10.02 0.5ZM14.59 9.24311C13.88 9.24311 13.31 9.81397 13.31 10.525C13.31 11.2261 13.88 11.807 14.59 11.807C15.3 11.807 15.87 11.2261 15.87 10.525C15.87 9.81397 15.3 9.24311 14.59 9.24311ZM9.98 9.24311C9.28 9.2331 8.7 9.81397 8.7 10.515C8.7 11.2261 9.27 11.7969 9.98 11.807C10.69 11.807 11.26 11.2261 11.26 10.525C11.26 9.81397 10.69 9.24311 9.98 9.24311ZM5.37 9.24311C4.66 9.24311 4.09 9.81397 4.09 10.525C4.09 11.2261 4.67 11.807 5.37 11.807C6.08 11.7969 6.65 11.2261 6.65 10.525C6.65 9.81397 6.08 9.24311 5.37 9.24311Z"
					fill="url(#paint0_linear_1589_21520)"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_1589_21520"
						x1="20"
						y1="20.5"
						x2="-6.65587"
						y2="18.4373"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor={typeof color === "string" ? color : "#346249"} />
						<stop offset="1" stopColor={typeof color === "string" ? color : "#57AB7A"} />
					</linearGradient>
				</defs>
			</svg>
		);
	}

	return (
		<svg
			width={bigger ? "30" : "21"}
			height={bigger ? "30" : "21"}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.02 0C15.7 0 20 4.65699 20 9.98498C20 16.1642 14.96 20 10 20C8.36 20 6.54 19.5593 5.08 18.698C4.57 18.3876 4.14 18.1572 3.59 18.3375L1.57 18.9384C1.06 19.0986 0.6 18.698 0.75 18.1572L1.42 15.9139C1.53 15.6034 1.51 15.2729 1.35 15.0125C0.49 13.4301 0 11.6975 0 10.015C0 4.74712 4.21 0 10.02 0ZM14.59 8.74311C13.88 8.74311 13.31 9.31397 13.31 10.025C13.31 10.7261 13.88 11.307 14.59 11.307C15.3 11.307 15.87 10.7261 15.87 10.025C15.87 9.31397 15.3 8.74311 14.59 8.74311ZM9.98 8.74311C9.28 8.7331 8.7 9.31397 8.7 10.015C8.7 10.7261 9.27 11.2969 9.98 11.307C10.69 11.307 11.26 10.7261 11.26 10.025C11.26 9.31397 10.69 8.74311 9.98 8.74311ZM5.37 8.74311C4.66 8.74311 4.09 9.31397 4.09 10.025C4.09 10.7261 4.67 11.307 5.37 11.307C6.08 11.2969 6.65 10.7261 6.65 10.025C6.65 9.31397 6.08 8.74311 5.37 8.74311Z"
				fill="white"
			/>
		</svg>
	);
}

function Profile({ color, tabs }: any) {
	return (
		<svg
			width={tabs ? "14" : "24"}
			height={tabs ? "15" : "24"}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9847 15.3462C8.11713 15.3462 4.81427 15.931 4.81427 18.2729C4.81427 20.6148 8.09617 21.2205 11.9847 21.2205C15.8524 21.2205 19.1543 20.6348 19.1543 18.2938C19.1543 15.9529 15.8733 15.3462 11.9847 15.3462Z"
				stroke={color || "white"}
				strokeWidth={tabs ? "2.5" : "1.5"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9848 12.0059C14.5229 12.0059 16.58 9.94779 16.58 7.40969C16.58 4.8716 14.5229 2.81445 11.9848 2.81445C9.44667 2.81445 7.38858 4.8716 7.38858 7.40969C7.38001 9.93922 9.42382 11.9973 11.9524 12.0059H11.9848Z"
				stroke={color || "white"}
				strokeWidth={tabs ? "2.5" : "1.42857"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function ProfileFilled() {
	return (
		<svg width="20" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.294 5.29105C13.294 8.22808 10.9391 10.5831 8 10.5831C5.0619 10.5831 2.70601 8.22808 2.70601 5.29105C2.70601 2.35402 5.0619 0 8 0C10.9391 0 13.294 2.35402 13.294 5.29105ZM8 20C3.66237 20 0 19.295 0 16.575C0 13.8539 3.68538 13.1739 8 13.1739C12.3386 13.1739 16 13.8789 16 16.599C16 19.32 12.3146 20 8 20Z"
				fill="white"
			/>
		</svg>
	);
}

function Caret() {
	return (
		<svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.00001 0.943529L7.5 7.25781L14 0.943531" stroke="#8E9AAB" strokeWidth="2" />
		</svg>
	);
}

function Message({ smaller, tabs, color }: any) {
	return (
		<svg
			width={smaller ? "17.5" : tabs ? "12" : "22"}
			height={smaller ? "15" : tabs ? "11" : "20"}
			viewBox="0 0 22 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.9026 6.85114L12.4593 10.4642C11.6198 11.1302 10.4387 11.1302 9.59919 10.4642L5.11841 6.85114"
				stroke={color || "#103246"}
				strokeWidth={smaller ? "2.5" : tabs ? "3" : "1.5"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.9089 19C18.9502 19.0084 21 16.5095 21 13.4384V6.57001C21 3.49883 18.9502 1 15.9089 1H6.09114C3.04979 1 1 3.49883 1 6.57001V13.4384C1 16.5095 3.04979 19.0084 6.09114 19H15.9089Z"
				stroke={color || "#103246"}
				strokeWidth={smaller ? "2.5" : tabs ? "3" : "1.5"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Lock({ tabs, color }: any) {
	return (
		<svg
			width={tabs ? "11" : "16"}
			height={tabs ? "12" : "18"}
			viewBox="0 0 16 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.3705 6.87321V5.08404C12.3705 2.98987 10.5872 1.29154 8.38835 1.29154C6.18948 1.28237 4.39923 2.97237 4.3896 5.06737V5.08404V6.87321"
				stroke={color || "#103246"}
				strokeWidth={tabs ? "2.5" : "1.5"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.7228 16.708H5.03693C3.20468 16.708 1.71893 15.2938 1.71893 13.548V9.97384C1.71893 8.22801 3.20468 6.81384 5.03693 6.81384H11.7228C13.5551 6.81384 15.0408 8.22801 15.0408 9.97384V13.548C15.0408 15.2938 13.5551 16.708 11.7228 16.708Z"
				stroke={color || "#103246"}
				strokeWidth={tabs ? "2.5" : "1.5"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.38004 10.8356V12.6864"
				stroke={color || "#103246"}
				strokeWidth={tabs ? "2.5" : "1.5"}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Bell() {
	return (
		<svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask
				id="mask0_1003_10500"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="20"
				height="19"
			>
				<path fillRule="evenodd" clipRule="evenodd" d="M0 0.0666504H19.73V18.5712H0V0.0666504Z" fill="white" />
			</mask>
			<g mask="url(#mask0_1003_10500)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.86334 1.66665C6.13534 1.66665 3.53695 4.58718 3.53695 7.20798C3.53695 9.42558 2.92148 10.4506 2.37748 11.3552C1.94121 12.0816 1.59668 12.6554 1.59668 13.9024C1.77481 15.9141 3.10281 16.9712 9.86334 16.9712C16.5865 16.9712 17.9561 15.8672 18.1332 13.833C18.13 12.6554 17.7855 12.0816 17.3492 11.3552C16.8052 10.4506 16.1897 9.42558 16.1897 7.20798C16.1897 4.58718 13.5913 1.66665 9.86334 1.66665ZM9.86348 18.5712C4.87575 18.5712 0.368014 18.2192 1.4245e-05 13.9706C-0.00318575 12.2128 0.533347 11.3189 1.00695 10.5317C1.48588 9.73385 1.93708 8.98185 1.93708 7.20798C1.93708 3.75945 5.12215 0.0666504 9.86348 0.0666504C14.6048 0.0666504 17.7899 3.75945 17.7899 7.20798C17.7899 8.98185 18.2411 9.73385 18.72 10.5317C19.1936 11.3189 19.7301 12.2128 19.7301 13.9024C19.3579 18.2192 14.8512 18.5712 9.86348 18.5712Z"
					fill="#103246"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.81149 23H9.80935C8.61362 22.9989 7.48189 22.472 6.62322 21.5152C6.32776 21.1877 6.35442 20.6811 6.68296 20.3867C7.01149 20.0902 7.51709 20.1168 7.81256 20.4464C8.36509 21.0619 9.07442 21.4 9.81042 21.4H9.81149C10.5507 21.4 11.2632 21.0619 11.8168 20.4454C12.1134 20.1179 12.619 20.0912 12.9464 20.3867C13.275 20.6822 13.3016 21.1888 13.0062 21.5163C12.1443 22.4731 11.0104 23 9.81149 23Z"
				fill="#103246"
			/>
		</svg>
	);
}

// Same bell as Icons.Bell with a diagonal cut (filled path, so the `path[fill="#103246"]` CSS recolor still applies).
function BellOff() {
	return (
		<svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<mask id="mask_bell_off" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="19">
				<path fillRule="evenodd" clipRule="evenodd" d="M0 0.0666504H19.73V18.5712H0V0.0666504Z" fill="white" />
			</mask>
			<g mask="url(#mask_bell_off)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.86334 1.66665C6.13534 1.66665 3.53695 4.58718 3.53695 7.20798C3.53695 9.42558 2.92148 10.4506 2.37748 11.3552C1.94121 12.0816 1.59668 12.6554 1.59668 13.9024C1.77481 15.9141 3.10281 16.9712 9.86334 16.9712C16.5865 16.9712 17.9561 15.8672 18.1332 13.833C18.13 12.6554 17.7855 12.0816 17.3492 11.3552C16.8052 10.4506 16.1897 9.42558 16.1897 7.20798C16.1897 4.58718 13.5913 1.66665 9.86334 1.66665ZM9.86348 18.5712C4.87575 18.5712 0.368014 18.2192 1.4245e-05 13.9706C-0.00318575 12.2128 0.533347 11.3189 1.00695 10.5317C1.48588 9.73385 1.93708 8.98185 1.93708 7.20798C1.93708 3.75945 5.12215 0.0666504 9.86348 0.0666504C14.6048 0.0666504 17.7899 3.75945 17.7899 7.20798C17.7899 8.98185 18.2411 9.73385 18.72 10.5317C19.1936 11.3189 19.7301 12.2128 19.7301 13.9024C19.3579 18.2192 14.8512 18.5712 9.86348 18.5712Z"
					fill="#103246"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.81149 23H9.80935C8.61362 22.9989 7.48189 22.472 6.62322 21.5152C6.32776 21.1877 6.35442 20.6811 6.68296 20.3867C7.01149 20.0902 7.51709 20.1168 7.81256 20.4464C8.36509 21.0619 9.07442 21.4 9.81042 21.4H9.81149C10.5507 21.4 11.2632 21.0619 11.8168 20.4454C12.1134 20.1179 12.619 20.0912 12.9464 20.3867C13.275 20.6822 13.3016 21.1888 13.0062 21.5163C12.1443 22.4731 11.0104 23 9.81149 23Z"
				fill="#103246"
			/>
			<path fillRule="evenodd" clipRule="evenodd" d="M1.58 1.71L2.82 0.69L19.02 20.29L17.78 21.31Z" fill="#103246" />
		</svg>
	);
}

function Door({ color }: any) {
	return (
		<svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.746 5.38951V4.45651C13.746 2.42151 12.096 0.771515 10.061 0.771515H5.18595C3.15195 0.771515 1.50195 2.42151 1.50195 4.45651V15.5865C1.50195 17.6215 3.15195 19.2715 5.18595 19.2715H10.071C12.1 19.2715 13.746 17.6265 13.746 15.5975V14.6545"
				stroke={color || "#103246"}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.5395 10.0214H8.49854"
				stroke={color || "#103246"}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.6111 7.10632L20.5391 10.0213L17.6111 12.9373"
				stroke={color || "#103246"}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Eye() {
	return (
		<svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.48964 9.9724C7.93061 9.49406 7.59033 8.84406 7.59033 8.1149C7.59033 6.65406 8.96311 5.47656 10.6664 5.47656C11.5094 5.47656 12.2852 5.76906 12.8345 6.2474"
				stroke="#103246"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.6853 8.58252C13.4597 9.65752 12.4719 10.5059 11.2188 10.7009"
				stroke="#103246"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.46987 12.5604C3.92695 11.522 2.62028 10.0054 1.67334 8.11452C2.63001 6.21535 3.94542 4.69035 5.49806 3.64369C7.04098 2.59702 8.82112 2.02869 10.6664 2.02869C12.5224 2.02869 14.3015 2.60535 15.8542 3.65952"
				stroke="#103246"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.9076 5.49243C18.5765 6.2541 19.1647 7.13326 19.6596 8.1141C17.7472 11.9116 14.3678 14.1991 10.6665 14.1991C9.82747 14.1991 9.00011 14.0824 8.20483 13.8549"
				stroke="#103246"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.3346 1.54138L2.99878 14.6864"
				stroke="#103246"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Camera({ color }: any) {
	return (
		<svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.30067 0H7.94908C9.89288 0 11.25 1.31105 11.25 3.18991V8.59283C11.25 10.4717 9.89288 11.7827 7.94908 11.7827H3.30067C1.35688 11.7827 -0.000244141 10.4717 -0.000244141 8.59283V3.18991C-0.000244141 1.31105 1.35688 0 3.30067 0ZM14.4118 1.86872C14.7642 1.69328 15.1775 1.71162 15.5138 1.91896C15.85 2.12551 16.0507 2.48438 16.0507 2.87674V8.90648C16.0507 9.29964 15.85 9.65771 15.5138 9.86425C15.33 9.9767 15.1245 10.0341 14.9175 10.0341C14.7449 10.0341 14.5724 9.99424 14.411 9.9137L13.2225 9.32675C12.7827 9.10824 12.5098 8.66963 12.5098 8.18237V3.60005C12.5098 3.11199 12.7827 2.67338 13.2225 2.45647L14.4118 1.86872Z"
				fill={color ?? "#3277A3"}
			/>
		</svg>
	);
}

function Clock({ color }: any) {
	return (
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.3957 7.00029C12.3957 9.98054 9.98009 12.3961 6.99984 12.3961C4.01959 12.3961 1.604 9.98054 1.604 7.00029C1.604 4.02004 4.01959 1.60446 6.99984 1.60446C9.98009 1.60446 12.3957 4.02004 12.3957 7.00029Z"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.00166 8.7167L6.80249 7.40478V4.57736"
				stroke={color === "white" || !color ? "white" : Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function SquareClock() {
	return (
		<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M23.2348 0.473145C28.5209 0.473145 32.0605 4.18241 32.0605 9.70186V22.4403C32.0605 27.9457 28.5209 31.6565 23.2348 31.6565H9.7154C4.42929 31.6565 0.874023 27.9457 0.874023 22.4403V9.70186C0.874023 4.18241 4.42929 0.473145 9.7154 0.473145H23.2348ZM15.9215 8.14269C15.2822 8.14269 14.752 8.67437 14.752 9.31207V17.1874C14.752 17.5928 14.9703 17.9826 15.329 18.1853L21.4415 21.8337C21.6286 21.9585 21.847 22.0053 22.0497 22.0053C22.4395 22.0053 22.8293 21.8026 23.0476 21.4284C23.3907 20.8811 23.2036 20.1639 22.6422 19.8224L17.091 16.517V9.31207C17.091 8.67437 16.5764 8.14269 15.9215 8.14269Z"
				fill="white"
			/>
		</svg>
	);
}

function Arrow({ color }: any) {
	return (
		<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.5 1L8.5 8L1.5 15"
				stroke={color ?? Variables.darkPrimaryColor}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Filters() {
	return (
		<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.33026 13.5929H1.02954"
				stroke="#130F26"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.1404 3.90036H16.4411"
				stroke="#130F26"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.72629 3.84625C5.72629 2.5506 4.66813 1.5 3.36314 1.5C2.05816 1.5 1 2.5506 1 3.84625C1 5.14191 2.05816 6.19251 3.36314 6.19251C4.66813 6.19251 5.72629 5.14191 5.72629 3.84625Z"
				stroke="#130F26"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17 13.5538C17 12.2581 15.9426 11.2075 14.6376 11.2075C13.3318 11.2075 12.2737 12.2581 12.2737 13.5538C12.2737 14.8494 13.3318 15.9 14.6376 15.9C15.9426 15.9 17 14.8494 17 13.5538Z"
				stroke="#130F26"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Send({ disabled }: any) {
	return (
		<svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.1554 15.6336C16.1554 15.6336 -3.80565 11.9219 3.13094 8.32259C8.98452 5.28548 29.1578 0.0637622 31.9761 1.41296C33.4771 3.94625 27.6679 22.0792 24.289 27.3408C20.2848 33.5758 16.1554 15.6336 16.1554 15.6336Z"
				stroke={disabled ? "#999" : "#DB633D"}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.1555 15.6335L31.9761 1.41284"
				stroke={disabled ? "#999" : "#DB633D"}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function Tick({ disabled }: any) {
	return (
		<svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0694 0H29.4868C36.297 0 40.8572 4.76 40.8572 11.84V28.182C40.8572 35.24 36.297 40 29.4868 40H12.0694C5.25917 40 0.678833 35.24 0.678833 28.182V11.84C0.678833 4.76 5.25917 0 12.0694 0ZM19.6229 25.98L29.1652 16.48C29.8483 15.8 29.8483 14.7 29.1652 14C28.4822 13.32 27.3572 13.32 26.6742 14L18.3773 22.26L14.8617 18.76C14.1787 18.08 13.0537 18.08 12.3707 18.76C11.6876 19.44 11.6876 20.54 12.3707 21.24L17.1519 25.98C17.4934 26.32 17.9354 26.48 18.3773 26.48C18.8394 26.48 19.2813 26.32 19.6229 25.98Z"
				fill={disabled ? "#d1d1d1" : "#3277A3"}
			/>
		</svg>
	);
}

function Star({ color, small, tabs }: any) {
	return (
		<svg
			width={tabs ? "11" : small ? "20" : "31"}
			height={tabs ? "12" : small ? "21" : "29"}
			viewBox="0 0 31 29"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M24.131 17.8835C23.7533 18.2495 23.5798 18.7789 23.6658 19.2981L24.9623 26.4731C25.0717 27.0812 24.815 27.6966 24.306 28.0481C23.8073 28.4127 23.1438 28.4564 22.5998 28.1647L16.1408 24.796C15.9163 24.6764 15.6669 24.6122 15.4117 24.605H15.0165C14.8794 24.6254 14.7452 24.6691 14.6227 24.7362L8.16229 28.121C7.84292 28.2814 7.48125 28.3383 7.12688 28.2814C6.26354 28.1181 5.6875 27.2956 5.82896 26.4279L7.12688 19.2529C7.21292 18.7293 7.03938 18.197 6.66167 17.8252L1.39563 12.721C0.95521 12.2937 0.802085 11.652 1.00333 11.0731C1.19875 10.4956 1.6975 10.0741 2.29979 9.97933L9.54771 8.92787C10.099 8.871 10.5831 8.53558 10.831 8.03975L14.0248 1.49183C14.1006 1.346 14.1983 1.21183 14.3165 1.09808L14.4477 0.995996C14.5163 0.920163 14.595 0.857454 14.6825 0.806413L14.8415 0.748079L15.0894 0.645996H15.7033C16.2517 0.702871 16.7344 1.031 16.9867 1.521L20.2227 8.03975C20.456 8.51662 20.9096 8.84766 21.4331 8.92787L28.681 9.97933C29.2935 10.0668 29.8054 10.4897 30.0081 11.0731C30.1992 11.6579 30.0344 12.2995 29.5852 12.721L24.131 17.8835Z"
				fill={color || "#D9DDDE"}
			/>
		</svg>
	);
}

function Pencil({ color }: any) {
	return (
		<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.1044 10.9231C12.3459 10.9231 12.5419 11.1191 12.5419 11.3606C12.5419 11.6021 12.3459 11.7981 12.1044 11.7981H7.87352C7.63202 11.7981 7.43602 11.6021 7.43602 11.3606C7.43602 11.1191 7.63202 10.9231 7.87352 10.9231H12.1044ZM9.40116 1.13129C9.43032 1.15404 10.4062 1.91237 10.4062 1.91237C10.7609 2.12354 11.038 2.50096 11.143 2.94779C11.2474 3.38996 11.1716 3.84612 10.9283 4.23171C10.9267 4.23428 10.9251 4.23682 10.9195 4.24438L10.9151 4.25022C10.8756 4.30226 10.7039 4.51929 9.83766 5.60463C9.82961 5.61886 9.82049 5.63218 9.81054 5.64512C9.79593 5.66421 9.78004 5.68175 9.76307 5.69772C9.70397 5.77211 9.64157 5.85029 9.57595 5.93247L9.44299 6.09899C9.16865 6.44256 8.84325 6.84997 8.4572 7.33319L8.25907 7.58117C7.51377 8.51401 6.55925 9.70839 5.33649 11.2381C5.06874 11.5718 4.66741 11.766 4.23632 11.7713L2.11357 11.7981H2.10774C1.90532 11.7981 1.72916 11.6593 1.68191 11.4615L1.20416 9.43679C1.10557 9.01737 1.20357 8.58454 1.47249 8.24854L6.96749 1.37571C6.96982 1.37337 6.97157 1.37046 6.97391 1.36812C7.57649 0.647708 8.66616 0.541542 9.40116 1.13129ZM6.35483 3.54242L2.15557 8.79512C2.05582 8.91996 2.01907 9.08096 2.05582 9.23554L2.45307 10.9185L4.22582 10.8963C4.39441 10.8945 4.55016 10.8193 4.65341 10.691C5.18511 10.0257 5.85336 9.18959 6.54041 8.32984L6.78348 8.02566L7.02697 7.72096C7.67131 6.9146 8.30787 6.11787 8.84049 5.451L6.35483 3.54242ZM7.64766 1.92637L6.90141 2.85875L9.38687 4.76679C9.86526 4.16757 10.18 3.77291 10.2091 3.73529C10.3047 3.58012 10.3421 3.36079 10.2919 3.14962C10.2406 2.93321 10.1058 2.74946 9.91157 2.63221C9.87016 2.60362 8.88724 1.84062 8.85691 1.81671C8.48707 1.52037 7.94749 1.57171 7.64766 1.92637Z"
				fill={color || "#103246"}
				stroke={color || "#103246"}
				strokeWidth="0.5"
			/>
		</svg>
	);
}

function Pencil2() {
	return (
		<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.836 11.6264C13.112 11.6264 13.336 11.8504 13.336 12.1264C13.336 12.4024 13.112 12.6264 12.836 12.6264H8.00068C7.72468 12.6264 7.50068 12.4024 7.50068 12.1264C7.50068 11.8504 7.72468 11.6264 8.00068 11.6264H12.836ZM9.74654 0.435762C9.77988 0.461762 10.8952 1.32843 10.8952 1.32843C11.3005 1.56976 11.6172 2.0011 11.7372 2.51176C11.8565 3.0171 11.7699 3.53843 11.4919 3.97909C11.49 3.98203 11.4882 3.98494 11.4817 3.99358L11.4767 4.00025C11.4316 4.05972 11.2354 4.30776 10.2454 5.54815C10.2362 5.56441 10.2258 5.57963 10.2144 5.59443C10.1977 5.61624 10.1795 5.63628 10.1602 5.65453C10.0926 5.73956 10.0213 5.8289 9.94631 5.92283L9.79435 6.11313C9.48082 6.50579 9.10893 6.97139 8.66773 7.52364L8.44131 7.80705C7.58952 8.87316 6.49865 10.2382 5.10121 11.9864C4.79521 12.3678 4.33654 12.5898 3.84388 12.5958L1.41788 12.6264H1.41121C1.17988 12.6264 0.978543 12.4678 0.924543 12.2418L0.378543 9.92776C0.265876 9.44843 0.377876 8.95376 0.68521 8.56976L6.96521 0.715095C6.96788 0.712428 6.96988 0.709095 6.97254 0.706428C7.66121 -0.116905 8.90654 -0.238238 9.74654 0.435762ZM6.26503 3.19133L1.46588 9.19443C1.35188 9.33709 1.30988 9.52109 1.35188 9.69776L1.80588 11.6211L3.83188 11.5958C4.02454 11.5938 4.20254 11.5078 4.32054 11.3611C4.9282 10.6008 5.69191 9.64525 6.47711 8.66268L6.75491 8.31504L7.03319 7.96681C7.76957 7.04526 8.49707 6.13471 9.10578 5.37258L6.26503 3.19133ZM7.74254 1.34443L6.88969 2.41L9.73021 4.59062C10.277 3.9058 10.6366 3.45476 10.6699 3.41176C10.7792 3.23443 10.8219 2.98376 10.7645 2.74243C10.7059 2.4951 10.5519 2.28509 10.3299 2.15109C10.2825 2.11843 9.15921 1.24643 9.12454 1.21909C8.70188 0.880428 8.08521 0.939095 7.74254 1.34443Z"
				fill="#103246"
			/>
		</svg>
	);
}

function Dashboard() {
	return (
		<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.897 0.8421C13.311 0.8421 13.647 1.1781 13.647 1.5921C13.647 2.0061 13.311 2.3421 12.897 2.3421H5.629C3.121 2.3421 1.5 4.0661 1.5 6.7361V14.8181C1.5 17.5231 3.082 19.2031 5.629 19.2031H14.233C16.741 19.2031 18.362 17.4821 18.362 14.8181V7.7791C18.362 7.3651 18.698 7.0291 19.112 7.0291C19.526 7.0291 19.862 7.3651 19.862 7.7791V14.8181C19.862 18.3381 17.6 20.7031 14.233 20.7031H5.629C2.262 20.7031 0 18.3381 0 14.8181V6.7361C0 3.2111 2.262 0.8421 5.629 0.8421H12.897ZM15.0124 7.6719C15.3404 7.9259 15.4004 8.3969 15.1464 8.7239L12.2164 12.5039C12.0944 12.6619 11.9144 12.7649 11.7164 12.7889C11.5164 12.8159 11.3184 12.7579 11.1604 12.6349L8.3424 10.4209L5.8114 13.7099C5.6634 13.9019 5.4414 14.0029 5.2164 14.0029C5.0564 14.0029 4.8954 13.9519 4.7594 13.8479C4.4314 13.5949 4.3694 13.1239 4.6224 12.7959L7.6154 8.9059C7.7374 8.7469 7.9184 8.6439 8.1164 8.6189C8.3184 8.5929 8.5164 8.6489 8.6734 8.7739L11.4934 10.9889L13.9604 7.8059C14.2144 7.4769 14.6844 7.4159 15.0124 7.6719ZM17.9674 0C19.4414 0 20.6394 1.198 20.6394 2.672C20.6394 4.146 19.4414 5.345 17.9674 5.345C16.4944 5.345 15.2954 4.146 15.2954 2.672C15.2954 1.198 16.4944 0 17.9674 0ZM17.9674 1.5C17.3214 1.5 16.7954 2.025 16.7954 2.672C16.7954 3.318 17.3214 3.845 17.9674 3.845C18.6134 3.845 19.1394 3.318 19.1394 2.672C19.1394 2.025 18.6134 1.5 17.9674 1.5Z"
				fill="white"
			/>
		</svg>
	);
}

function DashboardFilled() {
	return (
		<svg width="21" height="21" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.1798 2.41C15.1798 1.08 16.2598 0 17.5898 0C18.9198 0 19.9998 1.08 19.9998 2.41C19.9998 3.74 18.9198 4.82 17.5898 4.82C16.2598 4.82 15.1798 3.74 15.1798 2.41ZM11.3297 12.7593L14.2197 9.0303L14.1797 9.0503C14.3397 8.8303 14.3697 8.5503 14.2597 8.3003C14.1507 8.0503 13.9097 7.8803 13.6507 7.8603C13.3797 7.8303 13.1107 7.9503 12.9497 8.1703L10.5307 11.3003L7.75969 9.1203C7.58969 8.9903 7.38969 8.9393 7.18969 8.9603C6.99069 8.9903 6.81069 9.0993 6.68969 9.2593L3.73069 13.1103L3.66969 13.2003C3.49969 13.5193 3.57969 13.9293 3.87969 14.1503C4.01969 14.2403 4.16969 14.3003 4.33969 14.3003C4.57069 14.3103 4.78969 14.1893 4.92969 14.0003L7.43969 10.7693L10.2897 12.9103L10.3797 12.9693C10.6997 13.1393 11.0997 13.0603 11.3297 12.7593ZM13.4497 1.7803C13.4097 2.0303 13.3897 2.2803 13.3897 2.5303C13.3897 4.7803 15.2097 6.5993 17.4497 6.5993C17.6997 6.5993 17.9397 6.5703 18.1897 6.5303V14.5993C18.1897 17.9903 16.1897 20.0003 12.7897 20.0003H5.40069C1.99969 20.0003 -0.000305176 17.9903 -0.000305176 14.5993V7.2003C-0.000305176 3.8003 1.99969 1.7803 5.40069 1.7803H13.4497Z"
				fill="white"
			/>
		</svg>
	);
}

function Users() {
	return (
		<svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.8867 10.414L10.9996 10.414L11.2522 10.4149C13.1828 10.4276 17.5947 10.6226 17.5947 13.613C17.5947 16.5837 13.3366 16.7775 11.2823 16.7901L10.5212 16.7901C8.59051 16.7774 4.17772 16.5826 4.17772 13.596C4.17772 10.6215 8.59051 10.4275 10.5212 10.4149L10.7738 10.414C10.813 10.414 10.8507 10.414 10.8867 10.414ZM10.8867 11.914C8.51072 11.914 5.67772 12.206 5.67772 13.596C5.67772 14.9545 8.34163 15.2722 10.6696 15.2902L10.8867 15.291C13.2627 15.291 16.0947 15 16.0947 13.613C16.0947 12.209 13.2627 11.914 10.8867 11.914ZM18.8403 10.0082C21.2633 10.3712 21.7723 11.5092 21.7723 12.4002C21.7723 12.9442 21.5583 13.9372 20.1283 14.4822C20.0403 14.5152 19.9503 14.5312 19.8613 14.5312C19.5593 14.5312 19.2743 14.3472 19.1603 14.0482C19.0123 13.6612 19.2073 13.2272 19.5943 13.0802C20.2723 12.8222 20.2723 12.5372 20.2723 12.4002C20.2723 11.9622 19.7153 11.6562 18.6173 11.4922C18.2083 11.4302 17.9253 11.0492 17.9863 10.6382C18.0473 10.2282 18.4273 9.9552 18.8403 10.0082ZM3.78612 10.6382C3.84712 11.0492 3.56412 11.4302 3.15512 11.4922C2.05712 11.6562 1.50012 11.9622 1.50012 12.4002C1.50012 12.5372 1.50012 12.8212 2.17912 13.0802C2.56612 13.2272 2.76112 13.6612 2.61312 14.0482C2.49912 14.3472 2.21412 14.5312 1.91212 14.5312C1.82312 14.5312 1.73312 14.5152 1.64512 14.4822C0.214122 13.9362 0.00012207 12.9432 0.00012207 12.4002C0.00012207 11.5102 0.509122 10.3712 2.93312 10.0082C3.34612 9.9562 3.72412 10.2282 3.78612 10.6382ZM10.8867 0C13.4067 0 15.4557 2.05 15.4557 4.569C15.4557 7.088 13.4067 9.138 10.8867 9.138H10.8597C9.63972 9.134 8.49672 8.656 7.64072 7.792C6.78272 6.929 6.31372 5.783 6.31868 4.566C6.31868 2.05 8.36772 0 10.8867 0ZM10.8867 1.5C9.19472 1.5 7.8187 2.877 7.8187 4.569C7.81572 5.389 8.12972 6.156 8.70472 6.735C9.27972 7.314 10.0457 7.635 10.8617 7.638L10.8867 8.388V7.638C12.5787 7.638 13.9557 6.262 13.9557 4.569C13.9557 2.877 12.5787 1.5 10.8867 1.5ZM17.0757 0.9795C18.8337 1.2685 20.1107 2.7725 20.1107 4.5555C20.1067 6.3505 18.7657 7.8905 16.9907 8.1395C16.9557 8.1445 16.9207 8.1465 16.8867 8.1465C16.5187 8.1465 16.1977 7.8755 16.1447 7.5005C16.0877 7.0895 16.3727 6.7105 16.7837 6.6535C17.8237 6.5075 18.6087 5.6055 18.6107 4.5535C18.6107 3.5105 17.8627 2.6285 16.8317 2.4595C16.4237 2.3925 16.1467 2.0065 16.2137 1.5975C16.2817 1.1885 16.6647 0.9145 17.0757 0.9795ZM5.55972 1.5975C5.62672 2.0065 5.34972 2.3925 4.94172 2.4595C3.91072 2.6285 3.16272 3.5105 3.16272 4.5555C3.16472 5.6055 3.94972 6.5085 4.98872 6.6535C5.39972 6.7105 5.68472 7.0895 5.62772 7.5005C5.57472 7.8755 5.25372 8.1465 4.88572 8.1465C4.85172 8.1465 4.81672 8.1445 4.78172 8.1395C3.00672 7.8905 1.66672 6.3505 1.66272 4.5575C1.66272 2.7725 2.93972 1.2685 4.69772 0.9795C5.11872 0.9135 5.49172 1.1905 5.55972 1.5975Z"
				fill="white"
			/>
		</svg>
	);
}

function UsersFilled({ bigger }: any) {
	return (
		<svg
			width={bigger ? "35" : "22"}
			height={bigger ? "26" : "17"}
			viewBox="0 0 22 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.949 10.5396C14.3802 10.5396 17.31 11.0836 17.31 13.2604C17.31 15.4362 14.399 16 10.949 16C7.51785 16 4.58809 15.456 4.58809 13.2802C4.58809 11.1034 7.49904 10.5396 10.949 10.5396ZM16.4351 9.22888C17.7468 9.20456 19.1571 9.38468 19.6782 9.51257C20.7823 9.72962 21.5084 10.1727 21.8093 10.8166C22.0636 11.3453 22.0636 11.9586 21.8093 12.4864C21.349 13.4851 19.8654 13.8058 19.2887 13.8886C19.1696 13.9066 19.0738 13.8031 19.0864 13.6833C19.3809 10.9157 17.0377 9.60353 16.4315 9.30183C16.4055 9.28832 16.4002 9.2676 16.4028 9.255C16.4046 9.24599 16.4154 9.23158 16.4351 9.22888ZM5.31858 9.22701L5.5656 9.22924C5.5853 9.23194 5.59515 9.24635 5.59694 9.25446C5.59962 9.26796 5.59425 9.28778 5.56918 9.30219C4.9621 9.60389 2.61883 10.9161 2.91342 13.6827C2.92595 13.8034 2.83104 13.9061 2.71195 13.889C2.13531 13.8061 0.651629 13.4855 0.191392 12.4867C-0.0637974 11.9581 -0.0637974 11.3457 0.191392 10.817C0.492248 10.1731 1.21752 9.72998 2.32156 9.51203C2.84358 9.38504 4.25294 9.20492 5.5656 9.22924L5.31858 9.22701ZM10.949 0C13.2851 0 15.1583 1.88227 15.1583 4.23285C15.1583 6.58253 13.2851 8.4666 10.949 8.4666C8.61292 8.4666 6.73974 6.58253 6.73974 4.23285C6.73974 1.88227 8.61292 0 10.949 0ZM16.6634 0.705896C18.9198 0.705896 20.6918 2.84123 20.0883 5.21974C19.6809 6.82102 18.2062 7.88463 16.5631 7.8414C16.3984 7.8369 16.2363 7.82159 16.0796 7.79457C15.9659 7.77476 15.9086 7.64597 15.973 7.55051C16.5998 6.62288 16.9571 5.50703 16.9571 4.30922C16.9571 3.05918 16.5667 1.8938 15.8889 0.938252C15.8674 0.908532 15.8513 0.862601 15.8728 0.828378C15.8907 0.800459 15.9238 0.78605 15.9551 0.778845C16.1835 0.732013 16.4181 0.705896 16.6634 0.705896ZM5.33593 0.705806C5.58127 0.705806 5.81586 0.731923 6.04509 0.778755C6.07553 0.78596 6.10956 0.80127 6.12746 0.828288C6.14806 0.862511 6.13284 0.908442 6.11135 0.938162C5.43353 1.89371 5.04313 3.05909 5.04313 4.30913C5.04313 5.50694 5.4004 6.62279 6.02718 7.55042C6.09165 7.64588 6.03434 7.77467 5.92063 7.79448C5.76304 7.8224 5.60186 7.83681 5.43711 7.84131C3.79404 7.88454 2.31932 6.82093 1.91191 5.21965C1.30751 2.84114 3.07951 0.705806 5.33593 0.705806Z"
				fill="white"
			/>
		</svg>
	);
}

function Bin({ color }: any) {
	return (
		<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.9255 4.8133C11.2008 4.83596 11.4062 5.07663 11.3842 5.35196C11.3802 5.3973 11.0188 9.8713 10.8108 11.748C10.6815 12.9126 9.91217 13.6213 8.75084 13.6426C7.86217 13.658 7.00484 13.6666 6.16684 13.6666C5.26351 13.6666 4.38284 13.6566 3.51151 13.6386C2.39684 13.6166 1.62551 12.894 1.49951 11.7526C1.28951 9.8593 0.930175 5.39663 0.926841 5.35196C0.904175 5.07663 1.10951 4.8353 1.38484 4.8133C1.65617 4.80596 1.90151 4.99663 1.92351 5.2713C1.92564 5.30023 2.07253 7.12265 2.23262 8.92577L2.26477 9.2856C2.3454 10.1818 2.42712 11.0431 2.49351 11.6426C2.56484 12.2913 2.91484 12.626 3.53217 12.6386C5.19884 12.674 6.89951 12.676 8.73284 12.6426C9.38884 12.63 9.74351 12.302 9.81684 11.638C10.0235 9.7753 10.3835 5.31663 10.3875 5.2713C10.4095 4.99663 10.6528 4.80463 10.9255 4.8133ZM7.56604 0.333496C8.17804 0.333496 8.71604 0.746163 8.87404 1.3375L9.04337 2.17816C9.09809 2.45375 9.33994 2.655 9.61996 2.65942L11.8078 2.6595C12.0838 2.6595 12.3078 2.8835 12.3078 3.1595C12.3078 3.4355 12.0838 3.6595 11.8078 3.6595L9.6395 3.6594C9.63613 3.65946 9.63276 3.6595 9.62937 3.6595L9.61311 3.65883L2.69685 3.65941C2.69148 3.65947 2.68609 3.6595 2.68071 3.6595L2.67044 3.65883L0.502441 3.6595C0.226441 3.6595 0.00244141 3.4355 0.00244141 3.1595C0.00244141 2.8835 0.226441 2.6595 0.502441 2.6595L2.68977 2.65883L2.75712 2.65457C3.00798 2.62202 3.21647 2.4315 3.26737 2.17816L3.42937 1.3675C3.59404 0.746163 4.13204 0.333496 4.74404 0.333496H7.56604ZM7.56604 1.3335H4.74404C4.58404 1.3335 4.44337 1.44083 4.40271 1.59483L4.24737 2.37483C4.22763 2.47363 4.19889 2.56884 4.1621 2.65968H8.14818C8.11135 2.56884 8.08254 2.47363 8.06271 2.37483L7.90071 1.56416C7.86671 1.44083 7.72604 1.3335 7.56604 1.3335Z"
				fill={color || "#103246"}
			/>
		</svg>
	);
}

function Plus() {
	return (
		<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9873 0.417969C14.6864 0.417969 16.5 2.31267 16.5 5.13239V11.7036C16.5 14.5233 14.6864 16.418 11.9873 16.418H5.01274C2.31358 16.418 0.5 14.5233 0.5 11.7036V5.13239C0.5 2.31267 2.31358 0.417969 5.01274 0.417969H11.9873ZM11.9873 1.53425H5.01274C2.94986 1.53425 1.61628 2.94597 1.61628 5.13239V11.7036C1.61628 13.89 2.94986 15.3017 5.01274 15.3017H11.9873C14.0509 15.3017 15.3837 13.89 15.3837 11.7036V5.13239C15.3837 2.94597 14.0509 1.53425 11.9873 1.53425ZM8.5 5.12666C8.80809 5.12666 9.05814 5.3767 9.05814 5.6848V7.85239L11.2286 7.85254C11.5367 7.85254 11.7867 8.10258 11.7867 8.41068C11.7867 8.71877 11.5367 8.96881 11.2286 8.96881L9.05814 8.96867V11.1374C9.05814 11.4455 8.80809 11.6956 8.5 11.6956C8.19191 11.6956 7.94186 11.4455 7.94186 11.1374V8.96867L5.77144 8.96881C5.4626 8.96881 5.2133 8.71877 5.2133 8.41068C5.2133 8.10258 5.4626 7.85254 5.77144 7.85254L7.94186 7.85239V5.6848C7.94186 5.3767 8.19191 5.12666 8.5 5.12666Z"
				fill="#8E9AAB"
			/>
		</svg>
	);
}

function Upload() {
	return (
		<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.47466 5.28091C4.75066 5.28091 4.97466 5.50491 4.97466 5.78091C4.97466 6.05691 4.75066 6.28091 4.47466 6.28091H3.85266C2.77333 6.28091 1.896 7.15825 1.896 8.23691V11.4869C1.896 12.5662 2.77333 13.4436 3.85266 13.4436H11.2727C12.3513 13.4436 13.2293 12.5662 13.2293 11.4869V8.23091C13.2293 7.15558 12.3547 6.28091 11.28 6.28091H10.6513C10.3753 6.28091 10.1513 6.05691 10.1513 5.78091C10.1513 5.50491 10.3753 5.28091 10.6513 5.28091H11.28C12.906 5.28091 14.2293 6.60425 14.2293 8.23091V11.4869C14.2293 13.1176 12.9027 14.4436 11.2727 14.4436H3.85266C2.22266 14.4436 0.895996 13.1176 0.895996 11.4869V8.23691C0.895996 6.60691 2.22266 5.28091 3.85266 5.28091H4.47466ZM7.9164 0.899312L9.8604 2.85131C10.0551 3.04731 10.0544 3.36331 9.85906 3.55798C9.66306 3.75265 9.34706 3.75265 9.1524 3.55665L8.062 2.46248L8.0624 9.77885H7.0624L7.062 2.46248L5.97306 3.55665C5.87573 3.65531 5.74706 3.70398 5.61906 3.70398C5.49173 3.70398 5.36373 3.65531 5.2664 3.55798C5.07106 3.36331 5.06973 3.04731 5.26506 2.85131L7.2084 0.899312C7.39573 0.710646 7.72906 0.710646 7.9164 0.899312Z"
				fill="#8E9AAB"
			/>
		</svg>
	);
}

function UploadFile() {
	return (
		<svg width="35" height="41" viewBox="0 0 35 41" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.9518 0.500488C22.0378 0.500488 22.1222 0.50775 22.2043 0.521694L22.4746 0.523288C22.8826 0.523288 23.2726 0.689288 23.5566 0.983288L33.6886 11.5373C33.9546 11.8153 34.1048 12.1893 34.1048 12.5753V30.9553C34.1366 35.9733 30.2246 40.0513 25.1986 40.2313H8.91856C4.03811 40.1264 0.123971 36.1826 0.00329481 31.3518L0.00256348 9.48129C0.120563 4.51929 4.21656 0.523288 9.14056 0.523288L21.6992 0.521694C21.7813 0.50775 21.8657 0.500488 21.9518 0.500488ZM20.4506 3.52249L9.14656 3.52329C5.83256 3.52329 3.08056 6.20729 3.00256 9.51729V30.9553C2.93056 34.3573 5.61056 37.1573 8.98056 37.2313H25.1466C28.4846 37.1113 31.1266 34.3573 31.1047 30.9653L31.1046 14.4665L27.0878 14.4685C23.4258 14.4585 20.4518 11.4745 20.4518 7.81849L20.4506 3.52249ZM16.2834 14.8183C16.6974 14.8183 17.0724 14.9863 17.3439 15.2578L17.346 15.2591L22.038 19.9711C22.622 20.5591 22.62 21.5071 22.034 22.0911C21.446 22.6751 20.496 22.6751 19.912 22.0871L17.7826 19.9485L17.7834 28.4003C17.7834 29.2283 17.1114 29.9003 16.2834 29.9003C15.4554 29.9003 14.7834 29.2283 14.7834 28.4003L14.7826 19.9485L12.656 22.0871C12.364 22.3831 11.978 22.5291 11.594 22.5291C11.212 22.5291 10.828 22.3831 10.536 22.0911C9.94996 21.5071 9.94596 20.5591 10.532 19.9711L15.22 15.2591L15.2869 15.1974C15.3158 15.1717 15.3457 15.147 15.3766 15.1236L15.22 15.2591C15.2757 15.2031 15.3358 15.1527 15.3993 15.1078C15.6462 14.9257 15.9523 14.8183 16.2834 14.8183ZM23.4506 5.20449L23.4518 7.81849C23.4518 9.82649 25.0838 11.4625 27.0918 11.4685L29.4606 11.4665L23.4506 5.20449Z"
				fill="#8E9AAB"
			/>
		</svg>
	);
}

function Print() {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_1471_30856)">
				<path
					d="M21.5 18H18.5C18.224 18 18 17.776 18 17.5C18 17.224 18.224 17 18.5 17H21.5C22.327 17 23 16.327 23 15.5V8.5C23 7.673 22.327 7 21.5 7H2.5C1.673 7 1 7.673 1 8.5V15.5C1 16.327 1.673 17 2.5 17H5.5C5.776 17 6 17.224 6 17.5C6 17.776 5.776 18 5.5 18H2.5C1.121 18 0 16.878 0 15.5V8.5C0 7.122 1.121 6 2.5 6H21.5C22.879 6 24 7.122 24 8.5V15.5C24 16.878 22.879 18 21.5 18Z"
					fill="#103246"
				/>
				<path
					d="M14.5 21H8.5C8.224 21 8 20.776 8 20.5C8 20.224 8.224 20 8.5 20H14.5C14.776 20 15 20.224 15 20.5C15 20.776 14.776 21 14.5 21Z"
					fill="#103246"
				/>
				<path
					d="M14.5 19H8.5C8.224 19 8 18.776 8 18.5C8 18.224 8.224 18 8.5 18H14.5C14.776 18 15 18.224 15 18.5C15 18.776 14.776 19 14.5 19Z"
					fill="#103246"
				/>
				<path
					d="M10.5 17H8.5C8.224 17 8 16.776 8 16.5C8 16.224 8.224 16 8.5 16H10.5C10.776 16 11 16.224 11 16.5C11 16.776 10.776 17 10.5 17Z"
					fill="#103246"
				/>
				<path
					d="M18.5 6.99999C18.224 6.99999 18 6.77599 18 6.49999V2.5C18 1.673 17.327 0.999999 16.5 0.999999H7.5C6.673 0.999999 6 1.673 6 2.5V6.49999C6 6.77599 5.776 6.99999 5.5 6.99999C5.224 6.99999 5 6.77599 5 6.49999V2.5C5 1.122 6.121 0 7.5 0H16.5C17.879 0 19 1.122 19 2.5V6.49999C19 6.77599 18.776 6.99999 18.5 6.99999Z"
					fill="#103246"
				/>
				<path
					d="M16.5 24H7.5C6.121 24 5 22.878 5 21.5V13.5C5 13.224 5.224 13 5.5 13H18.5C18.776 13 19 13.224 19 13.5V21.5C19 22.878 17.879 24 16.5 24ZM6 14V21.5C6 22.327 6.673 23 7.5 23H16.5C17.327 23 18 22.327 18 21.5V14H6Z"
					fill="#103246"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1471_30856">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

function Phone({ isCall }: any) {
	return (
		<svg
			width={isCall ? "24" : "41"}
			height={isCall ? "24" : "41"}
			viewBox="0 0 41 41"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M36.9607 30.0203C35.8682 29.1041 29.4607 25.0466 28.3957 25.2328C27.8957 25.3216 27.5132 25.7478 26.4894 26.9691C26.016 27.5702 25.4961 28.1332 24.9344 28.6528C23.9054 28.4042 22.9094 28.035 21.9669 27.5528C18.271 25.7534 15.2852 22.7667 13.4869 19.0703C13.0047 18.1279 12.6355 17.1318 12.3869 16.1028C12.9066 15.5412 13.4696 15.0213 14.0707 14.5478C15.2907 13.5241 15.7182 13.1441 15.8069 12.6416C15.9932 11.5741 11.9319 5.16906 11.0194 4.07656C10.6369 3.62406 10.2894 3.32031 9.84444 3.32031C8.55444 3.32031 2.71944 10.5353 2.71944 11.4703C2.71944 11.5466 2.84444 19.0578 12.3307 28.7091C21.9819 38.1953 29.4932 38.3203 29.5694 38.3203C30.5044 38.3203 37.7194 32.4853 37.7194 31.1953C37.7194 30.7503 37.4157 30.4028 36.9607 30.0203Z"
				fill={isCall ? Variables.darkPrimaryColor : "white"}
			/>
			<path
				d="M28.9694 19.5703H31.4694C31.4665 16.9191 30.4119 14.3773 28.5372 12.5025C26.6625 10.6278 24.1207 9.57329 21.4694 9.57031V12.0703C23.458 12.0723 25.3645 12.8631 26.7705 14.2692C28.1766 15.6753 28.9675 17.5818 28.9694 19.5703Z"
				fill={isCall ? Variables.darkPrimaryColor : "white"}
			/>
			<path
				d="M35.2194 19.5703H37.7194C37.7145 15.2621 36.0008 11.1317 32.9544 8.08531C29.9081 5.03892 25.7777 3.32527 21.4694 3.32031V5.82031C25.1148 5.82461 28.6097 7.27465 31.1874 9.85234C33.7651 12.43 35.2151 15.9249 35.2194 19.5703Z"
				fill={isCall ? Variables.darkPrimaryColor : "white"}
			/>
		</svg>
	);
}

function Facebook() {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.38226 0.390625C1.95468 0.390625 0 2.3453 0 4.77287V20.0084C0 22.4359 1.95468 24.3906 4.38226 24.3906H12.6398V15.0081H10.1588V11.6301H12.6398V8.74412C12.6398 6.47672 14.1057 4.39487 17.4825 4.39487C18.8497 4.39487 19.8608 4.52613 19.8608 4.52613L19.7813 7.68063C19.7813 7.68063 18.7501 7.67089 17.625 7.67089C16.4073 7.67089 16.212 8.23196 16.212 9.1634V11.6301H19.878L19.7183 15.0081H16.212V24.3906H19.6177C22.0453 24.3906 24 22.4359 24 20.0084V4.7729C24 2.34532 22.0453 0.390649 19.6177 0.390649H4.38223L4.38226 0.390625Z"
				fill="white"
			/>
		</svg>
	);
}

function Instagram() {
	return (
		<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13 0.9375C16.3962 0.9375 16.82 0.95 18.1525 1.0125C19.4837 1.075 20.39 1.28375 21.1875 1.59375C22.0125 1.91125 22.7075 2.34125 23.4025 3.035C24.0381 3.65987 24.5299 4.41574 24.8438 5.25C25.1525 6.04625 25.3625 6.95375 25.425 8.285C25.4838 9.6175 25.5 10.0413 25.5 13.4375C25.5 16.8337 25.4875 17.2575 25.425 18.59C25.3625 19.9212 25.1525 20.8275 24.8438 21.625C24.5308 22.4597 24.0389 23.2158 23.4025 23.84C22.7775 24.4754 22.0216 24.9672 21.1875 25.2812C20.3912 25.59 19.4837 25.8 18.1525 25.8625C16.82 25.9213 16.3962 25.9375 13 25.9375C9.60375 25.9375 9.18 25.925 7.8475 25.8625C6.51625 25.8 5.61 25.59 4.8125 25.2812C3.97791 24.9681 3.22191 24.4762 2.5975 23.84C1.96176 23.2152 1.46991 22.4593 1.15625 21.625C0.84625 20.8287 0.6375 19.9212 0.575 18.59C0.51625 17.2575 0.5 16.8337 0.5 13.4375C0.5 10.0413 0.5125 9.6175 0.575 8.285C0.6375 6.9525 0.84625 6.0475 1.15625 5.25C1.46905 4.41522 1.961 3.65915 2.5975 3.035C3.22209 2.39904 3.97804 1.90716 4.8125 1.59375C5.61 1.28375 6.515 1.075 7.8475 1.0125C9.18 0.95375 9.60375 0.9375 13 0.9375ZM13 7.1875C11.3424 7.1875 9.75268 7.84598 8.58058 9.01808C7.40848 10.1902 6.75 11.7799 6.75 13.4375C6.75 15.0951 7.40848 16.6848 8.58058 17.8569C9.75268 19.029 11.3424 19.6875 13 19.6875C14.6576 19.6875 16.2473 19.029 17.4194 17.8569C18.5915 16.6848 19.25 15.0951 19.25 13.4375C19.25 11.7799 18.5915 10.1902 17.4194 9.01808C16.2473 7.84598 14.6576 7.1875 13 7.1875ZM21.125 6.875C21.125 6.4606 20.9604 6.06317 20.6674 5.77015C20.3743 5.47712 19.9769 5.3125 19.5625 5.3125C19.1481 5.3125 18.7507 5.47712 18.4576 5.77015C18.1646 6.06317 18 6.4606 18 6.875C18 7.2894 18.1646 7.68683 18.4576 7.97985C18.7507 8.27288 19.1481 8.4375 19.5625 8.4375C19.9769 8.4375 20.3743 8.27288 20.6674 7.97985C20.9604 7.68683 21.125 7.2894 21.125 6.875ZM13 9.6875C13.9946 9.6875 14.9484 10.0826 15.6517 10.7858C16.3549 11.4891 16.75 12.4429 16.75 13.4375C16.75 14.4321 16.3549 15.3859 15.6517 16.0892C14.9484 16.7924 13.9946 17.1875 13 17.1875C12.0054 17.1875 11.0516 16.7924 10.3483 16.0892C9.64509 15.3859 9.25 14.4321 9.25 13.4375C9.25 12.4429 9.64509 11.4891 10.3483 10.7858C11.0516 10.0826 12.0054 9.6875 13 9.6875Z"
				fill="white"
			/>
		</svg>
	);
}

function LinkedIn() {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.70544 0.396484C2.12023 0.396484 0.00439453 2.51228 0.00439453 5.09753V19.6857C0.00439453 22.2709 2.12019 24.386 4.70544 24.386H19.2936C21.8789 24.386 23.9939 22.2709 23.9939 19.6857V5.09753C23.9939 2.51232 21.8789 0.396484 19.2936 0.396484H4.70544ZM5.88783 4.35524C7.12738 4.35524 7.89089 5.16898 7.91446 6.23864C7.91446 7.28468 7.12733 8.12129 5.86385 8.12129H5.84059C4.62463 8.12129 3.83871 7.28472 3.83871 6.23864C3.83871 5.169 4.64842 4.35524 5.8878 4.35524H5.88783ZM16.5697 9.35468C18.9536 9.35468 20.7407 10.9128 20.7407 14.2611V20.5119H17.1178V14.6802C17.1178 13.2148 16.5935 12.215 15.2824 12.215C14.2815 12.215 13.6849 12.8889 13.423 13.5398C13.3273 13.7727 13.3038 14.098 13.3038 14.4238V20.5119H9.68091C9.68091 20.5119 9.72845 10.6332 9.68091 9.61032H13.3045V11.1541C13.786 10.4113 14.6471 9.35465 16.5697 9.35465V9.35468ZM4.0524 9.61112H7.67527V20.512H4.0524V9.61112Z"
				fill="white"
			/>
		</svg>
	);
}

function Minimize() {
	return (
		<svg width="16" height="17" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.8334 1.87785C12.1821 1.87785 11.5834 2.40577 11.5834 3.05744V10.6612L2.17835 1.05827C1.71752 0.597438 1.0696 0.597438 0.609185 1.05827C0.148352 1.51869 0.197935 2.26869 0.658769 2.7291L10.385 12.4099H2.6321C1.98085 12.4099 1.45252 13.0083 1.45252 13.6599C1.45252 14.3116 1.98085 14.9099 2.6321 14.9099H11.9788C13.2796 14.9099 14.0834 13.7045 14.0834 12.4037V3.05702C14.0834 2.40577 13.4846 1.87785 12.8334 1.87785Z"
				fill="black"
			/>
			<path
				d="M23.6587 22.4099H31.4121C32.0633 22.4099 32.5917 21.8116 32.5917 21.1599C32.5917 20.5082 32.0633 19.9099 31.4121 19.9099H22.0654C20.7646 19.9099 19.5 21.1153 19.5 22.4162V31.7628C19.5 32.4145 20.0988 32.9424 20.75 32.9424C21.4017 32.9424 22 32.4145 22 31.7628V24.1587L31.6354 33.7611C31.8658 33.9916 32.1842 34.1066 32.4858 34.1066C32.7879 34.1066 33.0979 33.9916 33.3283 33.7611C33.7892 33.3007 33.7929 32.5507 33.3325 32.0903L23.6587 22.4099Z"
				fill="black"
			/>
		</svg>
	);
}

function Maximize() {
	return (
		<svg width="16" height="17" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0.333252 3.004V12.3703C0.333252 13.0232 0.930336 13.5523 1.58325 13.5523C2.23617 13.5523 2.83325 13.0232 2.83325 12.3703V4.75025L11.9199 13.7844C12.1508 14.0153 12.4795 14.1307 12.782 14.1307C13.0845 14.1307 13.4003 14.0153 13.6308 13.7844C14.0924 13.3228 14.0991 12.4857 13.6374 12.0244L4.53492 2.8265H12.3045C12.9574 2.8265 13.4866 2.43775 13.4866 1.78483C13.4866 1.13191 12.9574 0.743164 12.3049 0.743164H2.93825C1.63492 0.743164 0.333252 1.70025 0.333252 3.004Z"
				fill="black"
			/>
			<path
				d="M33.6666 31.7406V22.3743C33.6666 21.7214 33.2779 21.1922 32.625 21.1922C31.972 21.1922 31.5833 21.7214 31.5833 22.3743V30.0093L22.1741 20.6214C21.7125 20.1597 20.9533 20.1597 20.4916 20.6214C20.03 21.0831 20.025 21.9576 20.4862 22.4189L29.9287 31.9931H22.1737C21.5208 31.9931 20.9916 32.3818 20.9916 33.0347C20.9916 33.6876 21.5208 34.0764 22.1737 34.0764H31.5404C32.8437 34.0764 33.6666 33.0443 33.6666 31.7406Z"
				fill="black"
			/>
			<path
				d="M21.269 14.1765C21.5715 14.1765 21.8957 14.0611 22.1261 13.8303L31.5832 4.39442V12.3703C31.5832 13.0232 31.9719 13.5523 32.6248 13.5523C33.2777 13.5523 33.6665 13.0232 33.6665 12.3703V3.004C33.6665 1.70025 32.8436 0.743164 31.5402 0.743164H22.1736C21.5207 0.743164 20.9915 1.13191 20.9915 1.78483C20.9915 2.43775 21.5207 2.8265 22.1736 2.8265H29.5877L20.4332 12.0698C19.9715 12.5315 19.9715 13.324 20.4332 13.7857C20.664 14.0165 20.9665 14.1765 21.269 14.1765Z"
				fill="black"
			/>
			<path
				d="M13.5795 20.6839C13.1178 20.2222 12.317 20.2222 11.8553 20.6839L2.83325 29.6535V22.3743C2.83325 21.7214 2.23617 21.1922 1.58325 21.1922C0.930336 21.1922 0.333252 21.7214 0.333252 22.3743V31.7405C0.333252 33.0443 1.63492 34.0764 2.93825 34.0764H12.3049C12.9578 34.0764 13.487 33.6876 13.487 33.0347C13.487 32.3818 12.9578 31.993 12.3049 31.993H4.1945L13.5799 22.4814C14.0412 22.0201 14.0412 21.1456 13.5795 20.6839Z"
				fill="black"
			/>
		</svg>
	);
}

function Menu() {
	return (
		<svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M22.635 18H1.63502C0.806558 18 0.13501 17.3284 0.13501 16.5C0.13501 15.6716 0.806558 15 1.63502 15H22.6351C23.4635 15 24.1351 15.6716 24.1351 16.5C24.135 17.3284 23.4635 18 22.635 18Z"
				fill="white"
			/>
			<path
				d="M22.635 10.5H1.63502C0.806558 10.5 0.13501 9.82842 0.13501 9.00001C0.13501 8.1716 0.806558 7.5 1.63502 7.5H22.6351C23.4635 7.5 24.1351 8.17155 24.1351 9.00001C24.1351 9.82847 23.4635 10.5 22.635 10.5Z"
				fill="white"
			/>
			<path
				d="M22.635 2.99996H1.63502C0.806558 2.99996 0.13501 2.32841 0.13501 1.49995C0.13501 0.671488 0.806558 -6.10352e-05 1.63502 -6.10352e-05H22.6351C23.4635 -6.10352e-05 24.1351 0.671488 24.1351 1.49995C24.1351 2.32841 23.4635 2.99996 22.635 2.99996Z"
				fill="white"
			/>
		</svg>
	);
}

function PhoneCall() {
	return (
		<svg width="25" height="10" viewBox="0 0 31 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.6236 7.1505C8.10279 7.15155 11.5994 12.3545 6.81183 12.3562C2.19529 12.3569 0.406039 13.2213 0.406852 7.37222C0.478793 6.7114 -0.735746 0.841225 15.6235 0.838948C31.9848 0.83667 30.7747 6.70718 30.8464 7.36798C30.8466 13.2323 29.0576 12.3521 24.4411 12.3527C19.6525 12.3534 23.1445 7.14946 15.6236 7.1505Z"
				fill="white"
			/>
		</svg>
	);
}

function VoiceCall() {
	return (
		<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle
				cx="14.4923"
				cy="14.5"
				r="13"
				fill="url(#paint0_linear_2439_3674)"
				stroke="#F5F8F8"
				strokeWidth="2"
			/>
			<path
				d="M20.2322 17.6543C19.8576 17.3401 17.6607 15.949 17.2956 16.0129C17.1242 16.0433 16.993 16.1894 16.642 16.6081C16.4797 16.8142 16.3014 17.0073 16.1089 17.1854C15.7561 17.1002 15.4146 16.9736 15.0915 16.8083C13.8243 16.1914 12.8006 15.1673 12.184 13.9C12.0187 13.5769 11.8921 13.2354 11.8069 12.8826C11.9851 12.69 12.1781 12.5118 12.3842 12.3494C12.8025 11.9984 12.949 11.8681 12.9795 11.6959C13.0433 11.3299 11.6509 9.13386 11.338 8.75929C11.2069 8.60414 11.0877 8.5 10.9352 8.5C10.4929 8.5 8.49231 10.9737 8.49231 11.2943C8.49231 11.3204 8.53517 13.8957 11.7876 17.2047C15.0966 20.4571 17.6719 20.5 17.698 20.5C18.0186 20.5 20.4923 18.4994 20.4923 18.0571C20.4923 17.9046 20.3882 17.7854 20.2322 17.6543V17.6543Z"
				fill="white"
			/>
			<path
				d="M17.4923 14.0714H18.3495C18.3484 13.1624 17.9869 12.2909 17.3441 11.6482C16.7014 11.0054 15.8299 10.6439 14.9209 10.6429V11.5C15.6027 11.5007 16.2563 11.7718 16.7384 12.2539C17.2205 12.736 17.4916 13.3896 17.4923 14.0714V14.0714Z"
				fill="white"
			/>
			<path
				d="M19.6352 14.0714H20.4923C20.4906 12.5943 19.9031 11.1782 18.8586 10.1337C17.8141 9.08924 16.398 8.5017 14.9209 8.5V9.35714C16.1708 9.35862 17.369 9.85577 18.2528 10.7396C19.1366 11.6233 19.6337 12.8216 19.6352 14.0714Z"
				fill="white"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_2439_3674"
					x1="26.4923"
					y1="26.5"
					x2="-5.49473"
					y2="24.0248"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#994227" />
					<stop offset="1" stopColor="#FA7348" />
				</linearGradient>
			</defs>
		</svg>
	);
}

function Report() {
	return (
		<svg width="16" height="16" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.909 0C16.053 0 18.165 2.153 18.165 5.357V14.553C18.165 17.785 16.118 19.887 12.95 19.907L5.257 19.91C2.113 19.91 0 17.757 0 14.553V5.357C0 2.124 2.047 0.023 5.215 0.004L12.908 0H12.909ZM12.909 1.5L5.22 1.504C2.892 1.518 1.5 2.958 1.5 5.357V14.553C1.5 16.968 2.905 18.41 5.256 18.41L12.945 18.407C15.273 18.393 16.665 16.951 16.665 14.553V5.357C16.665 2.942 15.261 1.5 12.909 1.5ZM12.7161 13.4737C13.1301 13.4737 13.4661 13.8097 13.4661 14.2237C13.4661 14.6377 13.1301 14.9737 12.7161 14.9737H5.4961C5.0821 14.9737 4.7461 14.6377 4.7461 14.2237C4.7461 13.8097 5.0821 13.4737 5.4961 13.4737H12.7161ZM12.7161 9.2872C13.1301 9.2872 13.4661 9.6232 13.4661 10.0372C13.4661 10.4512 13.1301 10.7872 12.7161 10.7872H5.4961C5.0821 10.7872 4.7461 10.4512 4.7461 10.0372C4.7461 9.6232 5.0821 9.2872 5.4961 9.2872H12.7161ZM8.2508 5.1104C8.6648 5.1104 9.0008 5.4464 9.0008 5.8604C9.0008 6.2744 8.6648 6.6104 8.2508 6.6104H5.4958C5.0818 6.6104 4.7458 6.2744 4.7458 5.8604C4.7458 5.4464 5.0818 5.1104 5.4958 5.1104H8.2508Z"
				fill="black"
			/>
		</svg>
	);
}

function CheckDouble() {
	return (
		<svg viewBox="0 0 16 11" height="11" width="16" xmlns="http://www.w3.org/2000/svg" fill="none">
			<path
				d="M11.0714 0.652832C10.991 0.585124 10.8894 0.55127 10.7667 0.55127C10.6186 0.55127 10.4916 0.610514 10.3858 0.729004L4.19688 8.36523L1.79112 6.09277C1.7488 6.04622 1.69802 6.01025 1.63877 5.98486C1.57953 5.95947 1.51817 5.94678 1.45469 5.94678C1.32351 5.94678 1.20925 5.99544 1.11192 6.09277L0.800883 6.40381C0.707784 6.49268 0.661235 6.60482 0.661235 6.74023C0.661235 6.87565 0.707784 6.98991 0.800883 7.08301L3.79698 10.0791C3.94509 10.2145 4.11224 10.2822 4.29844 10.2822C4.40424 10.2822 4.5058 10.259 4.60313 10.2124C4.70046 10.1659 4.78086 10.1003 4.84434 10.0156L11.4903 1.59863C11.5623 1.5013 11.5982 1.40186 11.5982 1.30029C11.5982 1.14372 11.5348 1.01888 11.4078 0.925781L11.0714 0.652832ZM8.6212 8.32715C8.43077 8.20866 8.2488 8.09017 8.0753 7.97168C7.99489 7.89128 7.8891 7.85107 7.75791 7.85107C7.6098 7.85107 7.4892 7.90397 7.3961 8.00977L7.10411 8.33984C7.01947 8.43717 6.97715 8.54508 6.97715 8.66357C6.97715 8.79476 7.0237 8.90902 7.1168 9.00635L8.1959 10.0791C8.33132 10.2145 8.49636 10.2822 8.69102 10.2822C8.79681 10.2822 8.89838 10.259 8.99571 10.2124C9.09304 10.1659 9.17556 10.1003 9.24327 10.0156L15.8639 1.62402C15.9358 1.53939 15.9718 1.43994 15.9718 1.32568C15.9718 1.1818 15.9125 1.05697 15.794 0.951172L15.4386 0.678223C15.3582 0.610514 15.2587 0.57666 15.1402 0.57666C14.9964 0.57666 14.8715 0.635905 14.7657 0.754395L8.6212 8.32715Z"
				fill="currentColor"
			></path>
		</svg>
	);
}

export default {
	AppStore,
	GooglePlay,
	Home,
	HomeFilled,
	Calendar,
	CalendarFilled,
	CheckDouble,
	Chat,
	ChatFilled,
	Profile,
	ProfileFilled,
	Caret,
	Message,
	Lock,
	Bell,
	BellOff,
	Door,
	Eye,
	Camera,
	Clock,
	SquareClock,
	Arrow,
	Filters,
	Send,
	Tick,
	Star,
	Pencil,
	Pencil2,
	Dashboard,
	DashboardFilled,
	Users,
	UsersFilled,
	Bin,
	Plus,
	Upload,
	UploadFile,
	Print,
	Phone,
	Facebook,
	Instagram,
	LinkedIn,
	Minimize,
	Maximize,
	Menu,
	PhoneCall,
	VoiceCall,
	Report
};
